var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mountains--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.81,199.05s-87-69-93.79-68.67c-5.18.26-14.93,8.09-14.93,8.09s-31.72-32-37.9-32.81-95.27,89.65-95.27,89.65V321.92H463.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.81,199.05s-87-69-93.79-68.67c-5.18.26-14.93,8.09-14.93,8.09s-31.72-32-37.9-32.81-95.27,89.65-95.27,89.65V321.92H463.81Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.81,199.05s-87-69-93.79-68.67c-5.18.26-14.93,8.09-14.93,8.09s-31.72-32-37.9-32.81-95.27,89.65-95.27,89.65V321.92H463.81Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,138.47l-12,9c3.62-2.72,6.91,1.7,12,1.52s7.94-4.53,12.83-3.17c4,1.13,5.57,2.85,8.4,3.3,5.17.83,3.74-2,6.67-2.61,2-.42,12.08,1.11,16.19,2.82-14.73-10.83-26.79-19.1-29.16-19a8.45,8.45,0,0,0-1.84.35,20.19,20.19,0,0,0-3.5,1.43l-1,.52a61.06,61.06,0,0,0-6.19,4c-1.47,1-2.42,1.82-2.42,1.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.7,125.2c3.92.31,10.28,4.08,12.93,1.7s8.62-6.62,11.23-4.18c-8.81-8.22-18.53-16.68-21.67-17.06-2.07-.25-13.4,9.68-27.56,23,5.95-3.47,10,.77,13.56,1.71S310.79,124.89,314.7,125.2Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.17,118.28c4.18,5.2-4.08,1.17-8.05,2.34s14.66,14,11.36,17.11c-1.84,1.7-13.75-2.87-11.51,1.28.72,1.34,13,10.93,7.26,11.66-3.41.44-8.08-1.33-6.12,3.52a25.72,25.72,0,0,0,5.74,8.55l32.24-24.27s-30.29-30.61-37.44-32.7l-.46-.11C315.89,106.09,320,113.07,324.17,118.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,130.38c-.2,0-.42.05-.63.08-2.08.93,3.28,7.28,4.4,9.61,1.22,2.53-10.28,0-10.75,1.7s15.59,13.28,15.77,15.35-14.43-1.93-14.87-.07,16.65,15.08,16.9,19c.13,2.11-6.16.52-11-1.19-3.38-1.19-9,0-4.06,5.76,2.9,3.4,98.06,75.77,98.06,75.77L463.7,199C460.35,196.31,376.69,130,370,130.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,184.63S209,131.07,203.2,131.36c-4.4.23-29.82,19.06-29.82,19.06s-29.62-26.56-34.88-27.2-98.29,71.5-98.29,71.5l.07,127.2H269.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.42,184.63S209,131.07,203.2,131.36c-4.4.23-29.82,19.06-29.82,19.06s-29.62-26.56-34.88-27.2-98.29,71.5-98.29,71.5l.07,127.2H269.45Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,131.36c-2.76.15-13.78,7.6-21.61,13.14,2.23.45,6,2.81,8.92,2.71,4.33-.16,7.63-4.13,10.72-2.41s6.66,6,10.63,6.65c6.37,1.05,7.34-1.59,10.76-.81a79.5,79.5,0,0,0,8.68,1.23C218,140.81,205.65,131.24,203.2,131.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.39,139.82c3.33.27,8.73,3.47,11,1.45s5.15-3.58,7.88-2.78,6.79,2.1,6.79,2.1h0c-9-7.63-20.49-17-23.58-17.36-1.72-.21-12.77,7.33-26.89,17.57,7.06-1.38,8.62,4.53,13.2,3.52C129.57,143.25,133.06,139.56,136.39,139.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.43,133.94c3.56,4.43-3.46,1-6.83,2s11.76,9.74,9,12.34c-1.56,1.45-9.12-2-7.22,1.5s14.24,14.13,14.24,14.13l19.81-13.49S145,125.09,138.89,123.31l-.39-.09C137.39,123.58,140.88,129.52,144.43,133.94Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,141.05c1,2.15-7.49-1.44-7.89,0s11.56,13.61,11.71,15.37-10.58-4-10.95-2.39,14.15,12.82,14.36,16.12c.12,1.79-5.23.44-9.37-1-2.87-1-7.63,0-3.45,4.89,2.45,2.87,69,58.6,69.86,59.28V184.63S209,131.07,203.2,131.36a3,3,0,0,0-.58.11C201,132.38,204.22,139.08,205.16,141.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Buildings--inject-48",
    d: "M454.64,240.7l-7.83,4.52V226.58l-3.91-2.26-7.83,4.52v3.5l-7.83,4.52V217.42l-7.83-4.52-7.83,4.52v2l-7.83,4.52V199.38l-7.83-4.52-7.84,4.52V186.63l-7.83-4.52-11.74,6.78v4.52l-7.83,4.52v3.71l-7.83-4.52V181.36s-7.69-4.3-7.83-4.3-7.83,4.3-7.83,4.3v6.72l-7.83-4.52-7.83,4.52v9l-7.83,4.52V178.72l-3.92-2.26-3.91,2.26v9L302,185.5,294.12,190v-6.88l-3.91-2.26-7.83,4.52v11.4l-3.92-2.26V190l-7.83-4.52L262.8,190V185.5l-11.74-6.78-7.83,4.52v-9l-7.83-4.52-7.83,4.52v12.56L223.65,189v-9l-7.83-4.52L208,180v13.56l-11.75-6.78v-9l-7.83-4.52-7.83,4.52v13.56L176.67,189l-7.83,4.52v5.52L161,203.58v-4.52l-7.83-4.52-11.75,6.78V191.11l-7.83-4.52-11.74,6.78v23.32l-11.75-6.78-15.66,9v-2l-7.83-4.52L78.79,217v10.43L71,231.93v10.64l-11.74,6.78v-4.92l-7.83-4.52-11.18,6.45v86.07h423.6V246Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Grass--inject-48",
    cx: 252.02,
    cy: 337.97,
    rx: 233.1,
    ry: 133.97,
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--grass--inject-48",
    cx: 252.02,
    cy: 337.97,
    rx: 233.1,
    ry: 133.97,
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Way--inject-48",
    d: "M347.53,460.22c106.89-62.74,43.31-109.86-14.19-132.54-25.64-10.11-57.93-17.12-66.26-22.72-12-8-5.7-18.72,29.59-26.48,37.67-8.29,77-25.22,64.61-42-14.23-19.2-52.37-27-73.21-30.9-6.18-.55-12.41-1-18.64-1.23,18.58,5.14,38.39,14.75,48.92,24.81,27.07,25.85-55.83,28.27-104.73,46.95-30.68,11.73-34.75,42.22,38.37,65.67,11.83,3.79,41.63,14.65,24.48,39.82-18.42,27-85.48,55.87-91.91,64.35-10.87,5.42-15.41,11.39-15.53,17.23C226.57,475.79,291.06,474.77,347.53,460.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flag--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--flag--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.16,91.88c2.92,0,5.35-.2,6.5,1S322.73,95,324.8,95s5-.16,4.7,1.13c-.15.69-.45,1.37-.15,1.61.71.57,1.89.82,4,.74-1.61.78-6.05.61-5.45-.31.41-.64-.71-.52-3.22-.52s-2.9-.77-2.52-1.71-5-.47-5-.47Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.16,107.6a.45.45,0,0,1-.45-.45V90.46a.46.46,0,1,1,.91,0v16.69A.45.45,0,0,1,317.16,107.6Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocks-2--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocks--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--grass--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.85,285.29c-.19,12.22,5.55,26.68,5.55,26.68l-2.8-1C422.83,294.72,424.85,285.29,424.85,285.29Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.85,285.29c-.19,12.22,5.55,26.68,5.55,26.68l-2.8-1C422.83,294.72,424.85,285.29,424.85,285.29Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,311.33c0,.05,0,.09.05.13l-1.38-.5c-4.77-16.24-2.75-25.67-2.75-25.67C423.89,291.36,426.49,305.13,428.93,311.33Z",
    style: {
      fill: "#438BAE",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,312a76.58,76.58,0,0,1,1.5-20.84c2.37-9.95,6.71-15,6.71-15s-5.7,4-9,14.77a64.77,64.77,0,0,0-2.89,19.73Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,312a76.58,76.58,0,0,1,1.5-20.84c2.37-9.95,6.71-15,6.71-15s-5.7,4-9,14.77a64.77,64.77,0,0,0-2.89,19.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.47,311.28h0l-1.75-.63a64.77,64.77,0,0,1,2.89-19.73c3.3-10.82,9-14.77,9-14.77C433.26,281.13,427.49,295.36,428.47,311.28Z",
    style: {
      fill: "#438BAE",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,312s.19-9.12,9.8-18.41A31,31,0,0,0,427.6,311Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,312s.19-9.12,9.8-18.41A31,31,0,0,0,427.6,311Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.93,311.33a.43.43,0,0,1,0,.11L427.6,311a31,31,0,0,1,12.6-17.4C435.65,297.4,430.36,303.51,428.93,311.33Z",
    style: {
      fill: "#438BAE",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocks--inject-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-48",
    points: "383.81 313.96 387.78 316.41 391.03 320.89 394.1 320.22 398.08 322.08 402.83 318.33 407.86 317.62 413.76 318.07 416.2 320.71 420.49 321.91 426.76 318.72 432.93 311.67 424.23 311.13 410.6 313.39 415.9 311.34 419.13 307.8 417.91 305.87 413.44 299.81 405.57 300.1 383.42 303.62 383.81 313.96",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocks--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rock--inject-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "397.18 290.89 387.67 297.26 384.46 301.85 390.69 302.72 398.62 306.34 400.66 301.33 397.03 296.39 397.18 290.89",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.18 290.89 387.67 297.26 384.46 301.85 390.69 302.72 398.62 306.34 400.66 301.33 397.03 296.39 397.18 290.89",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.18 290.89 403 291.07 404.28 296.96 400.66 301.33 397.03 296.39 397.18 290.89",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.18 290.89 403 291.07 404.28 296.96 400.66 301.33 397.03 296.39 397.18 290.89",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.51 297.35 412.34 301.96 408.12 300.63 403.09 303.28 400.84 306.13 399.12 311.71 397.4 319.53 394.86 312.83 398.62 306.34 402.33 302.1 407.81 300.13 411.51 297.35",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.29 315 413.39 308.92 410.31 303.53 406.29 315",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "411.51 297.35 412.34 301.96 408.12 300.63 403.09 303.28 400.84 306.13 399.12 311.71 397.4 319.53 394.86 312.83 398.62 306.34 402.33 302.1 407.81 300.13 411.51 297.35"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.29 315 413.39 308.92 410.31 303.53 406.29 315"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "391.63 294.61 388.19 298.66 387.41 300.91 390.86 301.05 398.62 306.34 390.69 302.72 384.46 301.85 387.67 297.26 391.63 294.61",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403 291.07 402.93 296.69 399.72 300.05 400.66 301.33 404.28 296.96 403 291.07",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.86 312.83 390.43 312.05 381.4 309.33 375.66 305.18 377.69 302.1 381.06 301.5 378.34 302.75 377.95 304.9 381.07 307.25 394.35 311.56 398.62 306.34 394.86 312.83",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "391.63 294.61 388.19 298.66 387.41 300.91 390.86 301.05 398.62 306.34 390.69 302.72 384.46 301.85 387.67 297.26 391.63 294.61"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "403 291.07 402.93 296.69 399.72 300.05 400.66 301.33 404.28 296.96 403 291.07"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.86 312.83 390.43 312.05 381.4 309.33 375.66 305.18 377.69 302.1 381.06 301.5 378.34 302.75 377.95 304.9 381.07 307.25 394.35 311.56 398.62 306.34 394.86 312.83"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "387.67 297.26 381.06 301.5 378.34 302.75 377.95 304.9 381.07 307.25 394.35 311.56 395.56 310.08 390.92 305.93 387.51 306.25 384.46 301.85 387.67 297.26",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.67 297.26 381.06 301.5 378.34 302.75 377.95 304.9 381.07 307.25 394.35 311.56 395.56 310.08 390.92 305.93 387.51 306.25 384.46 301.85 387.67 297.26",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403 291.07 411.51 297.35 407.81 300.13 402.33 302.1 398.62 306.34 400.66 301.33 404.28 296.96 403 291.07",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.12 300.63 403.09 303.28 400.84 306.13 399.12 311.71 400.72 316.84 406.29 315 410.31 303.53 408.12 300.63",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.46 301.85 387.51 306.25 390.92 305.93 390.69 302.72 384.46 301.85",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.11 312.55 382.95 313.21 384.32 311.63 390.43 312.05 381.4 309.33 380.11 312.55",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "403 291.07 411.51 297.35 407.81 300.13 402.33 302.1 398.62 306.34 400.66 301.33 404.28 296.96 403 291.07"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.12 300.63 403.09 303.28 400.84 306.13 399.12 311.71 400.72 316.84 406.29 315 410.31 303.53 408.12 300.63"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.46 301.85 387.51 306.25 390.92 305.93 390.69 302.72 384.46 301.85"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.11 312.55 382.95 313.21 384.32 311.63 390.43 312.05 381.4 309.33 380.11 312.55"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "393.01 312.51 390.43 312.05 388 314.99 390.55 318.25 393.01 312.51",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.01 312.51 390.43 312.05 388 314.99 390.55 318.25 393.01 312.51",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.34 301.96 415.73 306.39 413.39 308.92 410.31 303.53 408.12 300.63 412.34 301.96",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.4 319.53 400.72 316.84 399.12 311.71 397.4 319.53",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.62 306.34 395.56 310.08 390.92 305.93 390.69 302.72 398.62 306.34",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.66 305.18 374.31 309.07 380.11 312.55 381.4 309.33 375.66 305.18",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.4 319.53 390.55 318.25 393.01 312.51 394.86 312.83 397.4 319.53",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.95 313.21 388 314.99 390.43 312.05 384.32 311.63 382.95 313.21",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.34 301.96 415.73 306.39 413.39 308.92 410.31 303.53 408.12 300.63 412.34 301.96"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.4 319.53 400.72 316.84 399.12 311.71 397.4 319.53"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.62 306.34 395.56 310.08 390.92 305.93 390.69 302.72 398.62 306.34"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "375.66 305.18 374.31 309.07 380.11 312.55 381.4 309.33 375.66 305.18"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "397.4 319.53 390.55 318.25 393.01 312.51 394.86 312.83 397.4 319.53"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "382.95 313.21 388 314.99 390.43 312.05 384.32 311.63 382.95 313.21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rock--inject-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "420.19 303.44 414.95 306.94 413.19 309.47 416.62 309.95 420.98 311.94 422.11 309.18 420.11 306.46 420.19 303.44",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.19 303.44 414.95 306.94 413.19 309.47 416.62 309.95 420.98 311.94 422.11 309.18 420.11 306.46 420.19 303.44",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.19 303.44 423.4 303.54 424.1 306.78 422.11 309.18 420.11 306.46 420.19 303.44",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.19 303.44 423.4 303.54 424.1 306.78 422.11 309.18 420.11 306.46 420.19 303.44",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.08 306.99 428.54 309.53 426.21 308.8 423.44 310.26 422.21 311.83 421.26 314.9 420.31 319.2 418.92 315.51 420.98 311.94 423.03 309.61 426.04 308.52 428.08 306.99",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.21 316.71 429.11 313.36 427.42 310.4 425.21 316.71",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "428.08 306.99 428.54 309.53 426.21 308.8 423.44 310.26 422.21 311.83 421.26 314.9 420.31 319.2 418.92 315.51 420.98 311.94 423.03 309.61 426.04 308.52 428.08 306.99"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.21 316.71 429.11 313.36 427.42 310.4 425.21 316.71"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "417.13 305.48 415.24 307.71 414.81 308.95 416.71 309.03 420.98 311.94 416.62 309.95 413.19 309.47 414.95 306.94 417.13 305.48",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.4 303.54 423.36 306.63 421.59 308.48 422.11 309.18 424.1 306.78 423.4 303.54",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.92 315.51 416.48 315.09 411.5 313.59 408.34 311.3 409.46 309.61 411.32 309.28 409.82 309.96 409.6 311.15 411.32 312.44 418.63 314.81 420.98 311.94 418.92 315.51",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "417.13 305.48 415.24 307.71 414.81 308.95 416.71 309.03 420.98 311.94 416.62 309.95 413.19 309.47 414.95 306.94 417.13 305.48"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.4 303.54 423.36 306.63 421.59 308.48 422.11 309.18 424.1 306.78 423.4 303.54"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "418.92 315.51 416.48 315.09 411.5 313.59 408.34 311.3 409.46 309.61 411.32 309.28 409.82 309.96 409.6 311.15 411.32 312.44 418.63 314.81 420.98 311.94 418.92 315.51"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "414.95 306.94 411.32 309.28 409.82 309.96 409.6 311.15 411.32 312.44 418.63 314.81 419.3 314 416.74 311.72 414.87 311.89 413.19 309.47 414.95 306.94",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.95 306.94 411.32 309.28 409.82 309.96 409.6 311.15 411.32 312.44 418.63 314.81 419.3 314 416.74 311.72 414.87 311.89 413.19 309.47 414.95 306.94",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.4 303.54 428.08 306.99 426.04 308.52 423.03 309.61 420.98 311.94 422.11 309.18 424.1 306.78 423.4 303.54",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.21 308.8 423.44 310.26 422.21 311.83 421.26 314.9 422.14 317.72 425.21 316.71 427.42 310.4 426.21 308.8",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.19 309.47 414.87 311.89 416.74 311.72 416.62 309.95 413.19 309.47",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.79 315.36 412.36 315.73 413.11 314.86 416.48 315.09 411.5 313.59 410.79 315.36",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.45
    }
  }, _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.4 303.54 428.08 306.99 426.04 308.52 423.03 309.61 420.98 311.94 422.11 309.18 424.1 306.78 423.4 303.54"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "426.21 308.8 423.44 310.26 422.21 311.83 421.26 314.9 422.14 317.72 425.21 316.71 427.42 310.4 426.21 308.8"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.19 309.47 414.87 311.89 416.74 311.72 416.62 309.95 413.19 309.47"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.79 315.36 412.36 315.73 413.11 314.86 416.48 315.09 411.5 313.59 410.79 315.36"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "417.9 315.34 416.48 315.09 415.14 316.7 416.54 318.5 417.9 315.34",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.9 315.34 416.48 315.09 415.14 316.7 416.54 318.5 417.9 315.34",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.54 309.53 430.4 311.97 429.11 313.36 427.42 310.4 426.21 308.8 428.54 309.53",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.31 319.2 422.14 317.72 421.26 314.9 420.31 319.2",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.98 311.94 419.3 314 416.74 311.72 416.62 309.95 420.98 311.94",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.34 311.3 407.6 313.44 410.79 315.36 411.5 313.59 408.34 311.3",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.31 319.2 416.54 318.5 417.9 315.34 418.92 315.51 420.31 319.2",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.36 315.73 415.14 316.7 416.48 315.09 413.11 314.86 412.36 315.73",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "428.54 309.53 430.4 311.97 429.11 313.36 427.42 310.4 426.21 308.8 428.54 309.53"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "420.31 319.2 422.14 317.72 421.26 314.9 420.31 319.2"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "420.98 311.94 419.3 314 416.74 311.72 416.62 309.95 420.98 311.94"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.34 311.3 407.6 313.44 410.79 315.36 411.5 313.59 408.34 311.3"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "420.31 319.2 416.54 318.5 417.9 315.34 418.92 315.51 420.31 319.2"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.36 315.73 415.14 316.7 416.48 315.09 413.11 314.86 412.36 315.73"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-48",
    d: "M144.47,27.69c-1.56,1.16-3.88,1.17-5.91,1-2.37-.22-5.06-.46-6.85,1.12a19.72,19.72,0,0,0-2.18,2.91c-2,2.62-6.23,1-7.89,4.5-.23.51-.16,2.12-.81,2.31s-2.06-.8-2.75-.88a23.23,23.23,0,0,0-6.7.6,7.74,7.74,0,0,0-5,3.29c-.56.86-1,1.92-2,2.19a3.31,3.31,0,0,1-1.73-.14,20.6,20.6,0,0,0-6-1.13c-2.06.07-4.24,1.07-5,2.93-.11.26-.22.58-.5.65s-.55-.13-.77-.31a6.21,6.21,0,0,0-5.54-1.1,3.06,3.06,0,0,0-1.6,1c-.54.73-.5,1.74-1,2.47-.93,1.26-2.9,1-4.47.65-2.07-.44-4.48-.69-6.12.64-.44.36-.79.81-1.26,1.14-1.25.91-3,.73-4.52.67-1,0-13,1-12.74,2s3.21.63,3.89.66c1,0,2,.2,3,.18A8.39,8.39,0,0,1,63,55c.63.24,1.06.75,1.75.93a7.77,7.77,0,0,0,4.77-.61c1.75-.69,3.61-1.8,5.55-1.82a8.46,8.46,0,0,1,2.65.81,9.31,9.31,0,0,0,5.38-.19c1-.31,2.56-1.13,3.68-.9.63.13,1.34.71,2,.91a13.53,13.53,0,0,0,2.65.53c3.21.28,6.26-1.63,9.23-2.54,3.8-1.15,6-.42,9,1.69a9.27,9.27,0,0,0,8.74.91,23,23,0,0,1,2.55-1.13,10.09,10.09,0,0,1,6.73.15,16.14,16.14,0,0,0,3.92,1.69c4.59.82,8.66-4.71,13.19-3.61a12.23,12.23,0,0,1,2.6,1.14,39.83,39.83,0,0,0,7.88,2.62,4.57,4.57,0,0,0,1.51.22,4.37,4.37,0,0,0,1.93-.8,20.42,20.42,0,0,1,3.53-2,4.84,4.84,0,0,1,3.93,0A9.51,9.51,0,0,0,168,54.14c1.82.45,3.28-1.67,5.13-2s3.49,1.08,5.33.85,3.73-1.31,5.75-1.51c4.53-.45,9.16.5,13.61-.77a23,23,0,0,1,5.11-1.26c3.24-.16,6.47,1.76,9.6.93a.87.87,0,0,0,.34-.15c.33-.27.14-.86-.24-1.06a2.23,2.23,0,0,0-1.26-.12,10.7,10.7,0,0,1-3.94-.43,38.26,38.26,0,0,0-3.95-1.34c-4.21-.8-8.7,2.36-12.67.74a30.2,30.2,0,0,0-3.14-1.52c-2.26-.62-4.66.76-7,.34-1.85-.33-3.3-1.75-4.51-3.19a14.86,14.86,0,0,0-4-3.9c-1.66-.89-4-.81-5.1.74a14.88,14.88,0,0,0-1.82-4.23,5.08,5.08,0,0,0-3.79-2.33,3.71,3.71,0,0,1-2-.27,2.86,2.86,0,0,1-.83-1.92,8.68,8.68,0,0,0-4.19-5.81,16.13,16.13,0,0,0-4.67-1.77,3.69,3.69,0,0,0-3.21.81,21.58,21.58,0,0,0-1.39,2A4,4,0,0,1,144.47,27.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-48",
    d: "M241.9,62.86l-.34.17c-1.83.84-3.95.14-6,.16a8.18,8.18,0,0,0-5.29,2c-.86.77-1.55,1.71-2.39,2.51a10,10,0,0,1-8.15,2.65A20.35,20.35,0,0,0,217,70c-2.36,0-4.42,1.53-6.68,2.22-5,1.51-10.35-1.22-15.45-.28-2.86.53-5.43,2.18-8.31,2.55-1.77.23-3.6-.07-5.35.37,0,1,3.78,1.3,4.62,1.34a14.45,14.45,0,0,0,5.68-.83,31.74,31.74,0,0,1,3.45-1.26c2.91-.68,5.83.41,8.39,1.7a16.94,16.94,0,0,0,3.36.92c1.5.43,2.91,1.18,4.42,1.62a14.22,14.22,0,0,0,8.75.22c1.69-.61,3.21-1.67,4.95-2.12,2.92-.76,6,.33,8.68,1.75,1.65.87,3.38,1.91,5.23,1.67,2.6-.33,4.22-3,6.6-4.08,3.14-1.43,7-.22,10,1a33.38,33.38,0,0,0,5.23,1.82,11.29,11.29,0,0,0,5.48,0,29.33,29.33,0,0,1,4-1.31c1.64-.24,3.32.29,5,.06a10.08,10.08,0,0,0,1.7-.43,12.09,12.09,0,0,1,4.26-.65.5.5,0,0,0,.36-.08.36.36,0,0,0,.08-.33,1,1,0,0,0-.69-.73,3,3,0,0,0-1-.11c-2.15,0-4.31.15-6.46.34a16,16,0,0,1-5.69-.77c-1.36-.39-2.63-1-4-1.22a5.35,5.35,0,0,1-3-2.33c-1.13-1.44-2.33-3.3-4.35-3.43a2.75,2.75,0,0,1-1.15-.17c-.52-.27-.67-.93-.83-1.49a10.74,10.74,0,0,0-4.94-5.81,4.07,4.07,0,0,0-4.91.56A17.16,17.16,0,0,1,241.9,62.86Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-48"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "freepik--sun--inject-48",
    cx: 417.77,
    cy: 65.38,
    r: 14.07,
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.87,225.67a4,4,0,0,1,2.26.41,22.92,22.92,0,0,1,3.7,2.61,7.49,7.49,0,0,0,4.1,1.77,3.29,3.29,0,0,0,3.41-2.38,2.14,2.14,0,0,1,.2-.75,1.11,1.11,0,0,1,1.29-.34,7.69,7.69,0,0,1,1.24.72c1.53.91,3.45.7,5.21.44,1.46-.21,3.3-.85,3.3-2.33,0-1-.85-1.68-1.51-2.38s-1.2-1.82-.6-2.57a1.87,1.87,0,0,1,.85-.52c1.83-.59,4.06.2,5.61-.94a3.23,3.23,0,0,0,.81-3.87A4.91,4.91,0,0,0,99.45,213c-1.23-.31-2.79-.46-3.25-1.64-.4-1,.41-2.15,1.32-2.79a9.46,9.46,0,0,0,2.63-2,3.15,3.15,0,0,0,.09-3.27,4,4,0,0,0-2.75-1.89,6.3,6.3,0,0,1-1.68-.37,1.11,1.11,0,0,1-.61-1.41c.16-.3.51-.46.71-.74a1.34,1.34,0,0,0-.49-1.74,6.7,6.7,0,0,0-1.87-.71c-1.33-.44-1.41-1.69-1-3s1.11-1.89,1.68-3.23a2.9,2.9,0,0,0-1.36-3.29,23.71,23.71,0,0,0-3.52-1.57A3.73,3.73,0,0,1,87,182.55c-.1-1.31.89-2.42,1.69-3.46s1.49-2.51.79-3.63-2.18-1.13-3.39-1.52a5.49,5.49,0,0,1-3.33-3c-.32-.74-.47-1.56-.86-2.27-1.2-2.21-4.21-3.18-6.54-2.91a2.66,2.66,0,0,0-2.23,1.51,3.52,3.52,0,0,0-.81,1.53c-.15.92.26,2-.25,2.82s-1.7,1.16-2.43,1.84a4.47,4.47,0,0,0-1.18,3.07,5.11,5.11,0,0,0,.1,1.41,11.8,11.8,0,0,1,.52,2A2.46,2.46,0,0,1,67.88,182a3.27,3.27,0,0,1-2.24.47c-1.31,0-2.4-.07-3.36.92-1.68,1.74-.68,3.32.81,4.66,1.7,1.52.8,2.19.58,4.17-.11.95.11,1.25-.74,1.88-1.61,1.19-2.51.79-2.06,3.13.42,2.14-.22,1.4-2.07,2.2-1.64.71-2.73,2.47-4.06,3.58-.85.7-2.16,1.25-2.24,2.5-.15,2.38,2.81,1.86,4.22,2.43,2.3.93,1.62,3.94-.18,5.07s-4.68,1.64-4.83,4.37c-.12,2.09,1.07,2.55,2.7,3.25,1.29.56,1.13.73,1.13,2.27,0,3.12,1,4,4.12,3.5a7.69,7.69,0,0,1,3-.25c1.17.36.78.65.81,1.63.08,2.52,3,1.81,4.26.73C69.13,227.3,70.93,225.86,72.87,225.67Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.87,225.67a4,4,0,0,1,2.26.41,22.92,22.92,0,0,1,3.7,2.61,7.49,7.49,0,0,0,4.1,1.77,3.29,3.29,0,0,0,3.41-2.38,2.14,2.14,0,0,1,.2-.75,1.11,1.11,0,0,1,1.29-.34,7.69,7.69,0,0,1,1.24.72c1.53.91,3.45.7,5.21.44,1.46-.21,3.3-.85,3.3-2.33,0-1-.85-1.68-1.51-2.38s-1.2-1.82-.6-2.57a1.87,1.87,0,0,1,.85-.52c1.83-.59,4.06.2,5.61-.94a3.23,3.23,0,0,0,.81-3.87A4.91,4.91,0,0,0,99.45,213c-1.23-.31-2.79-.46-3.25-1.64-.4-1,.41-2.15,1.32-2.79a9.46,9.46,0,0,0,2.63-2,3.15,3.15,0,0,0,.09-3.27,4,4,0,0,0-2.75-1.89,6.3,6.3,0,0,1-1.68-.37,1.11,1.11,0,0,1-.61-1.41c.16-.3.51-.46.71-.74a1.34,1.34,0,0,0-.49-1.74,6.7,6.7,0,0,0-1.87-.71c-1.33-.44-1.41-1.69-1-3s1.11-1.89,1.68-3.23a2.9,2.9,0,0,0-1.36-3.29,23.71,23.71,0,0,0-3.52-1.57A3.73,3.73,0,0,1,87,182.55c-.1-1.31.89-2.42,1.69-3.46s1.49-2.51.79-3.63-2.18-1.13-3.39-1.52a5.49,5.49,0,0,1-3.33-3c-.32-.74-.47-1.56-.86-2.27-1.2-2.21-4.21-3.18-6.54-2.91a2.66,2.66,0,0,0-2.23,1.51,3.52,3.52,0,0,0-.81,1.53c-.15.92.26,2-.25,2.82s-1.7,1.16-2.43,1.84a4.47,4.47,0,0,0-1.18,3.07,5.11,5.11,0,0,0,.1,1.41,11.8,11.8,0,0,1,.52,2A2.46,2.46,0,0,1,67.88,182a3.27,3.27,0,0,1-2.24.47c-1.31,0-2.4-.07-3.36.92-1.68,1.74-.68,3.32.81,4.66,1.7,1.52.8,2.19.58,4.17-.11.95.11,1.25-.74,1.88-1.61,1.19-2.51.79-2.06,3.13.42,2.14-.22,1.4-2.07,2.2-1.64.71-2.73,2.47-4.06,3.58-.85.7-2.16,1.25-2.24,2.5-.15,2.38,2.81,1.86,4.22,2.43,2.3.93,1.62,3.94-.18,5.07s-4.68,1.64-4.83,4.37c-.12,2.09,1.07,2.55,2.7,3.25,1.29.56,1.13.73,1.13,2.27,0,3.12,1,4,4.12,3.5a7.69,7.69,0,0,1,3-.25c1.17.36.78.65.81,1.63.08,2.52,3,1.81,4.26.73C69.13,227.3,70.93,225.86,72.87,225.67Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.43,225.14a3.36,3.36,0,0,0-.59-.89c-.25-.28-.52-.54-.77-.81a3.35,3.35,0,0,1-.77-1.26,1.36,1.36,0,0,1,.17-1.31,1.3,1.3,0,0,1,.39-.31,2.4,2.4,0,0,1,.46-.21c.21-.06.43-.11.65-.15l.19,0a4.4,4.4,0,0,1,.51-.05l.17,0c.54,0,1.09,0,1.63,0l.29,0a1.84,1.84,0,0,0,.33,0l.35,0,.28-.05h0a16.45,16.45,0,0,0-2.47-.39,7,7,0,0,0-5.36,2.13A4.86,4.86,0,0,1,94,224.88c-3.49,1-6.92-3.72-10.24-2.3.2,1.68,0,3.95-1.63,4.32a2.67,2.67,0,0,1-2.54-1.22c-.6-.78-1-1.73-1.57-2.52a5.23,5.23,0,0,0-3.82-1.93,14.68,14.68,0,0,1-1.84.12A10.55,10.55,0,0,1,69.89,220c-.78-.42-1.67-1.07-1.54-1.95s1.05-1.19,1.6-1.8a2.31,2.31,0,0,0,.38-2.42c-.32-.7-1-1.25-1.08-2-.11-1,.91-1.87,1-2.9a2.68,2.68,0,0,0-1.7-2.23,12.1,12.1,0,0,1-2.64-1.33,1.87,1.87,0,0,1-.4-2.61c.23-.23.58-.4.67-.72a1,1,0,0,0-.21-.76,12.18,12.18,0,0,0-2.75-2.5c-1-.79-2.78-2.38-2.11-3.45-.32.34-.41.83-.2,1.94.42,2.14-.22,1.4-2.07,2.2-1.64.71-2.73,2.47-4.06,3.58h0c-.21.17-.45.34-.7.51-.73.51-1.48,1-1.54,2a2.46,2.46,0,0,0,.08.76,1.39,1.39,0,0,0,.32.54,1.43,1.43,0,0,0,.23.2,2.54,2.54,0,0,0,.57.29c.95.34,2.23.32,3,.64a2.29,2.29,0,0,1,.73.44,2.18,2.18,0,0,1,.73,1.64,3.59,3.59,0,0,1-1.64,3q-.36.22-.75.42c-.51.27-1.06.51-1.57.77a8,8,0,0,0-1.1.66,3.19,3.19,0,0,0-1.41,2.52,2.62,2.62,0,0,0,1.84,2.87c.27.13.55.25.86.38.81.35,1.05.55,1.11,1a4.09,4.09,0,0,1,0,.73v.52a6.76,6.76,0,0,0,.21,1.94,2.08,2.08,0,0,0,1.25,1.5,3.88,3.88,0,0,0,1.6.18c.32,0,.68-.06,1.06-.12a13.76,13.76,0,0,1,2.27-.33,2.59,2.59,0,0,1,.7.08,1.4,1.4,0,0,1,.76.41h0c.18.26,0,.61,0,1.22a1.78,1.78,0,0,0,.52,1.33,1.38,1.38,0,0,0,.25.17,1.89,1.89,0,0,0,.92.21,2,2,0,0,0,.35,0,4.44,4.44,0,0,0,1.68-.59,3.06,3.06,0,0,0,.54-.38l.81-.68a12.67,12.67,0,0,1,2.24-1.53,6.08,6.08,0,0,1,2.12-.66,3.84,3.84,0,0,1,1.12,0,3.89,3.89,0,0,1,1.14.37,8.5,8.5,0,0,1,1,.55q.48.31.93.66c.6.46,1.18,1,1.79,1.4a9.88,9.88,0,0,0,2.45,1.43,5.17,5.17,0,0,0,1.65.34,3.63,3.63,0,0,0,3-1.37,2.4,2.4,0,0,0,.43-1c0-.12,0-.26.07-.39a.92.92,0,0,1,.13-.36.64.64,0,0,1,.24-.25,1.22,1.22,0,0,1,.69-.16,2.29,2.29,0,0,1,.36.07,7.69,7.69,0,0,1,1.24.72,4.92,4.92,0,0,0,1.86.61l.66.05h.67a19.19,19.19,0,0,0,2-.22,4.61,4.61,0,0,0,3-1.37,1.64,1.64,0,0,0,.31-1A1.73,1.73,0,0,0,97.43,225.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.07,200l8.39,16.64V209l.86-32.62L78.56,209v5.15L87.78,198l-9.22,19.8V262a.53.53,0,0,1-.31.43,1.61,1.61,0,0,1-1.48,0,.53.53,0,0,1-.31-.43V220.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M68.44,264c4.11.65,7.78-.48,8.41-4.93a39.42,39.42,0,0,0,0-11c-.19-1.31-.66-2.87-1.94-3.21a2.44,2.44,0,0,0-2.65,1.48,7.18,7.18,0,0,0-.45,3.23c-.65-1.44-1.61-3.1-3.19-3.14s-2.57,1.5-2.62,3a8.52,8.52,0,0,0,1.34,4.12,4,4,0,0,0-3.2.5A2.8,2.8,0,0,0,64,257.6a8.16,8.16,0,0,0,3.22,2.31,1.45,1.45,0,0,0-2,.95,2.2,2.2,0,0,0,.83,2.21A4.78,4.78,0,0,0,68.44,264Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M75.57,265.71,85.38,260a7.74,7.74,0,0,0,2.13-2,5.47,5.47,0,0,0,1.19-2.54,1.27,1.27,0,0,0-.1-1c-.35-.52-1.19-.34-1.66.08a18.28,18.28,0,0,0-1.33,1.32,15,15,0,0,0,.19-3.41,1.51,1.51,0,0,0-.42-1.13,1.26,1.26,0,0,0-1.37,0c-1.28.69-1.83,2.22-2.27,3.61a11.9,11.9,0,0,0-.13-4.33c-.34-1.54-2.12-2.15-2.72-.67a8.25,8.25,0,0,0-.52,2.47,9.9,9.9,0,0,0,.22,3.26A10.24,10.24,0,0,0,76,252.13a1.59,1.59,0,0,0-1.51-.53c-.62.24-.72,1.07-.66,1.73a9.24,9.24,0,0,0,1.34,3.95A8.35,8.35,0,0,0,71.82,256a1,1,0,0,0-1,.34,1.31,1.31,0,0,0,.23,1.36,8.15,8.15,0,0,0,2.63,2.45,8.69,8.69,0,0,0-3.21-.34,1.11,1.11,0,0,0-.86.37c-.28.4.05.95.41,1.3a9.93,9.93,0,0,0,2.29,1.37,3.42,3.42,0,0,0-1.42.23,1.15,1.15,0,0,0-.67,1.17,1.44,1.44,0,0,0,1,.91C73.13,265.8,73.66,266,75.57,265.71Z",
    style: {
      fill: "#438BAE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.18,234.86a4.77,4.77,0,0,1,2.62.47,25.91,25.91,0,0,1,4.28,3,8.71,8.71,0,0,0,4.75,2,3.83,3.83,0,0,0,4-2.75,2.38,2.38,0,0,1,.22-.88,1.29,1.29,0,0,1,1.5-.39,8.06,8.06,0,0,1,1.44.84c1.77,1,4,.8,6,.51,1.69-.25,3.82-1,3.82-2.71,0-1.11-1-1.94-1.75-2.75s-1.39-2.11-.69-3a2,2,0,0,1,1-.61c2.12-.68,4.71.23,6.5-1.09a3.73,3.73,0,0,0,.94-4.48A5.71,5.71,0,0,0,66,220.22c-1.42-.36-3.23-.53-3.75-1.89-.47-1.2.46-2.5,1.52-3.24s2.32-1.25,3.05-2.31a3.66,3.66,0,0,0,.1-3.79,4.61,4.61,0,0,0-3.19-2.18,7.31,7.31,0,0,1-1.93-.43,1.29,1.29,0,0,1-.72-1.63c.19-.35.6-.53.83-.85a1.55,1.55,0,0,0-.57-2,8,8,0,0,0-2.17-.83c-1.53-.51-3-2-2.57-3.55s2.68-2.14,3.34-3.69c.58-1.38-.34-3-1.57-3.82a28.78,28.78,0,0,0-4.08-1.82c-1.35-.63-2.65-1.76-2.76-3.24s1-2.81,2-4,1.72-2.9.91-4.2-2.52-1.31-3.92-1.76a6.36,6.36,0,0,1-3.86-3.48c-.37-.86-.55-1.8-1-2.62-1.39-2.56-4.88-3.69-7.58-3.37a3.08,3.08,0,0,0-2.58,1.75,4.07,4.07,0,0,0-.94,1.77c-.21,1.24.45,2.81-.72,3.76-1.77,1.44-4.49-.5-4.4,2.71a14,14,0,0,0,.6,4c.49,1.34,1.45,1.93.65,3.44-1,2-1.73,2-3.81,1.94-1.52,0-2.78-.08-3.89,1.07-2,2-.79,3.84.94,5.39,2,1.77.93,2.55.67,4.84-.12,1.1.13,1.44-.86,2.17-1.86,1.38-2.9.92-2.38,3.63.48,2.47-.26,1.62-2.4,2.54-1.9.82-3.16,2.87-4.7,4.15-1,.82-2.5,1.45-2.59,2.89-.18,2.76,3.25,2.16,4.88,2.82,2.67,1.07,1.87,4.57-.21,5.88s-5.41,1.89-5.59,5c-.13,2.43,1.24,3,3.12,3.77,1.5.65,1.31.84,1.31,2.63,0,3.61,1.21,4.63,4.77,4.05a9,9,0,0,1,3.44-.29c1.36.41.9.75.94,1.89.1,2.92,3.49,2.09,4.93.84C30.85,236.75,32.93,235.08,35.18,234.86Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.18,234.86a4.77,4.77,0,0,1,2.62.47,25.91,25.91,0,0,1,4.28,3,8.71,8.71,0,0,0,4.75,2,3.83,3.83,0,0,0,4-2.75,2.38,2.38,0,0,1,.22-.88,1.29,1.29,0,0,1,1.5-.39,8.06,8.06,0,0,1,1.44.84c1.77,1,4,.8,6,.51,1.69-.25,3.82-1,3.82-2.71,0-1.11-1-1.94-1.75-2.75s-1.39-2.11-.69-3a2,2,0,0,1,1-.61c2.12-.68,4.71.23,6.5-1.09a3.73,3.73,0,0,0,.94-4.48A5.71,5.71,0,0,0,66,220.22c-1.42-.36-3.23-.53-3.75-1.89-.47-1.2.46-2.5,1.52-3.24s2.32-1.25,3.05-2.31a3.66,3.66,0,0,0,.1-3.79,4.61,4.61,0,0,0-3.19-2.18,7.31,7.31,0,0,1-1.93-.43,1.29,1.29,0,0,1-.72-1.63c.19-.35.6-.53.83-.85a1.55,1.55,0,0,0-.57-2,8,8,0,0,0-2.17-.83c-1.53-.51-3-2-2.57-3.55s2.68-2.14,3.34-3.69c.58-1.38-.34-3-1.57-3.82a28.78,28.78,0,0,0-4.08-1.82c-1.35-.63-2.65-1.76-2.76-3.24s1-2.81,2-4,1.72-2.9.91-4.2-2.52-1.31-3.92-1.76a6.36,6.36,0,0,1-3.86-3.48c-.37-.86-.55-1.8-1-2.62-1.39-2.56-4.88-3.69-7.58-3.37a3.08,3.08,0,0,0-2.58,1.75,4.07,4.07,0,0,0-.94,1.77c-.21,1.24.45,2.81-.72,3.76-1.77,1.44-4.49-.5-4.4,2.71a14,14,0,0,0,.6,4c.49,1.34,1.45,1.93.65,3.44-1,2-1.73,2-3.81,1.94-1.52,0-2.78-.08-3.89,1.07-2,2-.79,3.84.94,5.39,2,1.77.93,2.55.67,4.84-.12,1.1.13,1.44-.86,2.17-1.86,1.38-2.9.92-2.38,3.63.48,2.47-.26,1.62-2.4,2.54-1.9.82-3.16,2.87-4.7,4.15-1,.82-2.5,1.45-2.59,2.89-.18,2.76,3.25,2.16,4.88,2.82,2.67,1.07,1.87,4.57-.21,5.88s-5.41,1.89-5.59,5c-.13,2.43,1.24,3,3.12,3.77,1.5.65,1.31.84,1.31,2.63,0,3.61,1.21,4.63,4.77,4.05a9,9,0,0,1,3.44-.29c1.36.41.9.75.94,1.89.1,2.92,3.49,2.09,4.93.84C30.85,236.75,32.93,235.08,35.18,234.86Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,228.7c1.63-.52,3.53-.11,5.14-.49a19.75,19.75,0,0,0-2.88-.45,8.17,8.17,0,0,0-6.21,2.46A5.62,5.62,0,0,1,59.64,234c-4,1.09-8-4.32-11.85-2.67.23,1.95,0,4.58-1.9,5A3.09,3.09,0,0,1,43,234.88c-.69-.92-1.12-2-1.82-2.92a6.17,6.17,0,0,0-8.2-1.2c-1,.76-2.35,1.9-3.39,1.15s-.44-3-1.67-3.62c-.82-.41-2,.24-2.66-.37a1.9,1.9,0,0,1-.47-1c-.49-2.06-.91-4.45.38-6.12,1.16-1.49,3.6-2.41,3.34-4.28-.22-1.59-2.25-2.08-3.86-2.26s-3.62-.94-3.54-2.55,2.22-2.35,2.53-3.9c.14-.66-.09-1.4.21-2,.46-.91,1.76-1,2.53-1.62,1.37-1.21.3-3.48.69-5.27.28-1.26,1.3-2.26,1.64-3.5.68-2.5-1.59-4.87-4-5.89a14.41,14.41,0,0,1-2.7-1.25l-.09-.07a5,5,0,0,0,1.95,3.12c2,1.77.93,2.55.67,4.84-.12,1.1.13,1.44-.86,2.17-1.86,1.38-2.9.92-2.38,3.63.48,2.47-.26,1.62-2.4,2.54-1.9.82-3.16,2.87-4.7,4.15-1,.82-2.5,1.45-2.59,2.89-.18,2.76,3.25,2.16,4.88,2.82,2.67,1.07,1.87,4.57-.21,5.88s-5.41,1.89-5.59,5c-.13,2.43,1.24,3,3.12,3.77,1.5.65,1.31.84,1.31,2.63,0,3.61,1.21,4.63,4.77,4.05a9,9,0,0,1,3.44-.29c1.36.41.9.75.94,1.89.1,2.92,3.49,2.09,4.93.84,1.66-1.43,3.74-3.1,6-3.32a4.77,4.77,0,0,1,2.62.47,25.91,25.91,0,0,1,4.28,3,8.71,8.71,0,0,0,4.75,2,3.83,3.83,0,0,0,4-2.75,2.38,2.38,0,0,1,.22-.88,1.29,1.29,0,0,1,1.5-.39,8.06,8.06,0,0,1,1.44.84c1.77,1,4,.8,6,.51,1.69-.25,3.82-1,3.82-2.71,0-1.11-1-1.94-1.75-2.75s-1.39-2.11-.69-3A2,2,0,0,1,62.34,228.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.62,205.1l9.72,19.27V215.5l1-37.77,1.44,37.77v6l10.68-18.68L41.77,225.72v58.54a.61.61,0,0,1-.35.49,1.93,1.93,0,0,1-1.72,0,.6.6,0,0,1-.36-.49v-55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M33.75,288.83c2.78.44,5.27-.32,5.7-3.33a26.63,26.63,0,0,0,0-7.46c-.12-.89-.44-2-1.31-2.18a1.66,1.66,0,0,0-1.79,1,4.79,4.79,0,0,0-.31,2.19c-.44-1-1.09-2.1-2.16-2.12a2,2,0,0,0-1.77,2,5.68,5.68,0,0,0,.9,2.79,2.75,2.75,0,0,0-2.17.34,1.91,1.91,0,0,0-.08,2.47,5.63,5.63,0,0,0,2.18,1.56,1,1,0,0,0-1.32.65,1.49,1.49,0,0,0,.57,1.49A3.21,3.21,0,0,0,33.75,288.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M38.58,290l6.65-3.84a5.46,5.46,0,0,0,1.44-1.36,3.85,3.85,0,0,0,.81-1.72.88.88,0,0,0-.07-.66c-.24-.35-.81-.23-1.13.06a12.46,12.46,0,0,0-.9.89,9.85,9.85,0,0,0,.13-2.3,1,1,0,0,0-.28-.77.85.85,0,0,0-.93,0,3.92,3.92,0,0,0-1.54,2.45,8.08,8.08,0,0,0-.09-2.94c-.23-1.05-1.43-1.46-1.84-.45a5.59,5.59,0,0,0-.35,1.67,6.84,6.84,0,0,0,.15,2.21,6.88,6.88,0,0,0-1.78-2.46,1.08,1.08,0,0,0-1-.36c-.42.17-.49.73-.45,1.17a6.38,6.38,0,0,0,.91,2.68,5.76,5.76,0,0,0-2.25-.88.69.69,0,0,0-.71.23.93.93,0,0,0,.16.93,5.5,5.5,0,0,0,1.79,1.66A5.76,5.76,0,0,0,35.1,286a.74.74,0,0,0-.58.24c-.19.28,0,.65.27.89a6.75,6.75,0,0,0,1.56.92,2.37,2.37,0,0,0-1,.16.76.76,0,0,0-.46.79,1,1,0,0,0,.7.62A4.7,4.7,0,0,0,38.58,290Z",
    style: {
      fill: "#438BAE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.93,224.19a4.22,4.22,0,0,0-2.27.41,23.62,23.62,0,0,0-3.7,2.62,7.43,7.43,0,0,1-4.1,1.77,3.29,3.29,0,0,1-3.41-2.38,2.19,2.19,0,0,0-.2-.76,1.1,1.1,0,0,0-1.29-.33,6.45,6.45,0,0,0-1.24.72c-1.53.9-3.45.7-5.21.44-1.46-.21-3.3-.86-3.3-2.34,0-1,.85-1.67,1.51-2.37s1.2-1.82.6-2.57a1.74,1.74,0,0,0-.85-.52c-1.83-.6-4.06.2-5.61-.95a3.23,3.23,0,0,1-.81-3.86,4.88,4.88,0,0,1,3.29-2.51c1.23-.32,2.79-.46,3.25-1.64s-.41-2.16-1.31-2.79a9.59,9.59,0,0,1-2.64-2,3.15,3.15,0,0,1-.09-3.27A4,4,0,0,1,407.3,200a5.94,5.94,0,0,0,1.68-.37,1.11,1.11,0,0,0,.62-1.4c-.17-.31-.52-.46-.72-.74a1.34,1.34,0,0,1,.49-1.74,7.18,7.18,0,0,1,1.87-.72c1.33-.44,2.61-1.72,2.22-3.06s-2.31-1.85-2.88-3.19a2.91,2.91,0,0,1,1.36-3.3,24.79,24.79,0,0,1,3.52-1.57,3.73,3.73,0,0,0,2.38-2.8c.1-1.32-.89-2.42-1.69-3.47s-1.49-2.51-.79-3.62,2.18-1.14,3.39-1.52a5.51,5.51,0,0,0,3.33-3c.32-.74.47-1.55.86-2.26,1.2-2.22,4.21-3.19,6.54-2.91a2.64,2.64,0,0,1,2.23,1.51,3.52,3.52,0,0,1,.81,1.53c.18,1.07-.39,2.43.62,3.24,1.53,1.24,3.88-.43,3.8,2.35a11.54,11.54,0,0,1-.52,3.45c-.42,1.17-1.25,1.67-.56,3,.9,1.69,1.49,1.68,3.3,1.67,1.3,0,2.39-.07,3.35.92,1.68,1.74.68,3.32-.81,4.66-1.7,1.53-.8,2.2-.58,4.18.11.95-.11,1.24.74,1.87,1.61,1.2,2.51.79,2.06,3.13-.41,2.14.22,1.41,2.07,2.2,1.64.71,2.73,2.48,4.06,3.58.85.71,2.16,1.26,2.24,2.5.15,2.38-2.81,1.86-4.22,2.43-2.3.93-1.62,3.95.18,5.08s4.68,1.64,4.83,4.36c.12,2.1-1.07,2.56-2.7,3.26-1.29.56-1.13.72-1.12,2.27,0,3.12-1.05,4-4.13,3.49a7.69,7.69,0,0,0-3-.24c-1.17.35-.77.64-.81,1.63-.08,2.51-3,1.8-4.26.73C435.66,225.82,433.87,224.38,431.93,224.19Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.93,224.19a4.22,4.22,0,0,0-2.27.41,23.62,23.62,0,0,0-3.7,2.62,7.43,7.43,0,0,1-4.1,1.77,3.29,3.29,0,0,1-3.41-2.38,2.19,2.19,0,0,0-.2-.76,1.1,1.1,0,0,0-1.29-.33,6.45,6.45,0,0,0-1.24.72c-1.53.9-3.45.7-5.21.44-1.46-.21-3.3-.86-3.3-2.34,0-1,.85-1.67,1.51-2.37s1.2-1.82.6-2.57a1.74,1.74,0,0,0-.85-.52c-1.83-.6-4.06.2-5.61-.95a3.23,3.23,0,0,1-.81-3.86,4.88,4.88,0,0,1,3.29-2.51c1.23-.32,2.79-.46,3.25-1.64s-.41-2.16-1.31-2.79a9.59,9.59,0,0,1-2.64-2,3.15,3.15,0,0,1-.09-3.27A4,4,0,0,1,407.3,200a5.94,5.94,0,0,0,1.68-.37,1.11,1.11,0,0,0,.62-1.4c-.17-.31-.52-.46-.72-.74a1.34,1.34,0,0,1,.49-1.74,7.18,7.18,0,0,1,1.87-.72c1.33-.44,2.61-1.72,2.22-3.06s-2.31-1.85-2.88-3.19a2.91,2.91,0,0,1,1.36-3.3,24.79,24.79,0,0,1,3.52-1.57,3.73,3.73,0,0,0,2.38-2.8c.1-1.32-.89-2.42-1.69-3.47s-1.49-2.51-.79-3.62,2.18-1.14,3.39-1.52a5.51,5.51,0,0,0,3.33-3c.32-.74.47-1.55.86-2.26,1.2-2.22,4.21-3.19,6.54-2.91a2.64,2.64,0,0,1,2.23,1.51,3.52,3.52,0,0,1,.81,1.53c.18,1.07-.39,2.43.62,3.24,1.53,1.24,3.88-.43,3.8,2.35a11.54,11.54,0,0,1-.52,3.45c-.42,1.17-1.25,1.67-.56,3,.9,1.69,1.49,1.68,3.3,1.67,1.3,0,2.39-.07,3.35.92,1.68,1.74.68,3.32-.81,4.66-1.7,1.53-.8,2.2-.58,4.18.11.95-.11,1.24.74,1.87,1.61,1.2,2.51.79,2.06,3.13-.41,2.14.22,1.41,2.07,2.2,1.64.71,2.73,2.48,4.06,3.58.85.71,2.16,1.26,2.24,2.5.15,2.38-2.81,1.86-4.22,2.43-2.3.93-1.62,3.95.18,5.08s4.68,1.64,4.83,4.36c.12,2.1-1.07,2.56-2.7,3.26-1.29.56-1.13.72-1.12,2.27,0,3.12-1.05,4-4.13,3.49a7.69,7.69,0,0,0-3-.24c-1.17.35-.77.64-.81,1.63-.08,2.51-3,1.8-4.26.73C435.66,225.82,433.87,224.38,431.93,224.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.25,211.57c-1.8-1.13-2.48-4.15-.18-5.08,1.41-.57,4.37-.05,4.22-2.43-.08-1.24-1.39-1.79-2.24-2.5-1.33-1.1-2.42-2.87-4.06-3.58-1.85-.79-2.48-.06-2.07-2.2.45-2.34-.45-1.93-2.06-3.13-.78-.58-.66-.88-.72-1.67a4.4,4.4,0,0,0-.92,1.23c-.62,1.34-.12,2.94.57,4.25.52,1,1.1,2.33.27,3.09a4.24,4.24,0,0,1-1.36.58,2.73,2.73,0,0,0-1.66,2.21c-.1,1,.41,2.16,0,3.13a3.93,3.93,0,0,1-1.51,1.49,5.39,5.39,0,0,0-2.6,3.46c-.25,2.1,1.61,3.79,3.26,5.13.55.45,1.08,1.38.46,1.74a1.38,1.38,0,0,1-.76.08,3,3,0,0,0-2.41,1.09c-.54.68-.88,1.68-1.73,1.85a2.52,2.52,0,0,1-1-.07,7.15,7.15,0,0,0-6.51,2.28c-.9,1-2,2.46-3.25,1.92-1.08-.48-1.1-2.08-2-2.81a1.51,1.51,0,0,0-.26-.18c-1.18-.72-2.62-.11-3.74.42-.69.33-1.36.69-2.06,1s-1.43.7-2.13.3a1.18,1.18,0,0,1-.53-1.4c.12-.39.3-.76.41-1.15a1.65,1.65,0,0,0,0-1.2,1.88,1.88,0,0,0-.8-.78,5.56,5.56,0,0,0-2-.7l-.11,0a13.63,13.63,0,0,0-2.39,0,8,8,0,0,1-2.49-.14,3.08,3.08,0,0,1-2-1.42h0a2.79,2.79,0,0,0,1,1.55c1.55,1.15,3.78.35,5.61.95a1.74,1.74,0,0,1,.85.52c.6.75.06,1.87-.6,2.57s-1.5,1.41-1.51,2.37c0,1.48,1.84,2.13,3.3,2.34,1.76.26,3.68.46,5.21-.44a6.45,6.45,0,0,1,1.24-.72,1.1,1.1,0,0,1,1.29.33,2.19,2.19,0,0,1,.2.76,3.29,3.29,0,0,0,3.41,2.38,7.43,7.43,0,0,0,4.1-1.77,23.62,23.62,0,0,1,3.7-2.62,4.22,4.22,0,0,1,2.27-.41c1.94.19,3.73,1.63,5.16,2.88,1.25,1.07,4.18,1.78,4.26-.73,0-1-.36-1.28.81-1.63a7.69,7.69,0,0,1,3,.24c3.08.51,4.13-.37,4.13-3.49,0-1.55-.17-1.71,1.12-2.27,1.63-.7,2.82-1.16,2.7-3.26C452.93,213.21,450.15,212.76,448.25,211.57Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.72,198.5l-8.39,16.64v-7.66l-.85-32.61-1.25,32.61v5.15L417,196.51l9.22,19.79v44.24a.52.52,0,0,0,.31.42,1.61,1.61,0,0,0,1.48,0,.5.5,0,0,0,.31-.42V219.38Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M436.35,262.48c-4.1.66-7.78-.48-8.41-4.92a39.42,39.42,0,0,1,0-11c.19-1.32.66-2.88,1.95-3.22a2.45,2.45,0,0,1,2.64,1.49,7.18,7.18,0,0,1,.45,3.23c.65-1.44,1.62-3.11,3.2-3.14s2.56,1.5,2.61,3a8.41,8.41,0,0,1-1.34,4.12,4,4,0,0,1,3.2.5,2.8,2.8,0,0,1,.12,3.64,8.24,8.24,0,0,1-3.22,2.3,1.46,1.46,0,0,1,2,1,2.24,2.24,0,0,1-.84,2.21A4.87,4.87,0,0,1,436.35,262.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M429.23,264.23l-9.82-5.66a7.9,7.9,0,0,1-2.13-2,5.56,5.56,0,0,1-1.19-2.54,1.3,1.3,0,0,1,.1-1c.35-.52,1.19-.34,1.66.08a18.28,18.28,0,0,1,1.33,1.32,15.5,15.5,0,0,1-.19-3.4,1.58,1.58,0,0,1,.42-1.14,1.28,1.28,0,0,1,1.37,0c1.28.7,1.83,2.23,2.27,3.62a11.89,11.89,0,0,1,.13-4.33c.35-1.55,2.12-2.15,2.72-.68a8.38,8.38,0,0,1,.52,2.47,9.9,9.9,0,0,1-.22,3.26,10.12,10.12,0,0,1,2.62-3.62,1.57,1.57,0,0,1,1.51-.53c.62.24.72,1.07.66,1.73a9.25,9.25,0,0,1-1.34,3.94,8.5,8.5,0,0,1,3.32-1.29,1,1,0,0,1,1,.34,1.35,1.35,0,0,1-.22,1.37,8.41,8.41,0,0,1-2.64,2.45,8.49,8.49,0,0,1,3.21-.34,1.1,1.1,0,0,1,.86.36c.28.41-.05,1-.4,1.3a9.52,9.52,0,0,1-2.3,1.37,3.43,3.43,0,0,1,1.42.24,1.13,1.13,0,0,1,.67,1.16,1.45,1.45,0,0,1-1,.92C431.66,264.33,431.13,264.54,429.23,264.23Z",
    style: {
      fill: "#438BAE"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.06,234.86a4.77,4.77,0,0,0-2.62.47,26.34,26.34,0,0,0-4.28,3,8.71,8.71,0,0,1-4.75,2,3.83,3.83,0,0,1-4-2.75,2.38,2.38,0,0,0-.22-.88,1.28,1.28,0,0,0-1.49-.39,7.81,7.81,0,0,0-1.45.84c-1.77,1-4,.8-6,.51-1.7-.25-3.83-1-3.83-2.71,0-1.11,1-1.94,1.75-2.75s1.39-2.11.69-3a2,2,0,0,0-1-.61c-2.12-.68-4.71.23-6.5-1.09a3.74,3.74,0,0,1-.93-4.48,5.67,5.67,0,0,1,3.81-2.91c1.42-.36,3.23-.53,3.76-1.89.46-1.2-.47-2.5-1.52-3.24s-2.33-1.25-3.06-2.31a3.66,3.66,0,0,1-.1-3.79,4.61,4.61,0,0,1,3.19-2.18,7.48,7.48,0,0,0,1.94-.43,1.29,1.29,0,0,0,.71-1.63c-.19-.35-.59-.53-.82-.85a1.55,1.55,0,0,1,.57-2,7.93,7.93,0,0,1,2.16-.83c1.53-.51,3-2,2.57-3.55s-2.68-2.14-3.34-3.69c-.57-1.38.34-3,1.58-3.82a28.66,28.66,0,0,1,4.07-1.82c1.35-.63,2.65-1.76,2.76-3.24s-1-2.81-2-4-1.72-2.9-.91-4.2,2.52-1.31,3.92-1.76a6.36,6.36,0,0,0,3.86-3.48c.37-.86.55-1.8,1-2.62,1.38-2.56,4.87-3.69,7.58-3.37a3.08,3.08,0,0,1,2.57,1.75,3.88,3.88,0,0,1,.94,1.77c.21,1.24-.44,2.81.72,3.76,1.78,1.44,4.5-.5,4.4,2.71a14,14,0,0,1-.6,4c-.48,1.34-1.45,1.93-.65,3.44,1.05,2,1.73,2,3.82,1.94,1.51,0,2.77-.08,3.88,1.07,1.95,2,.79,3.84-.94,5.39-2,1.77-.92,2.55-.67,4.84.13,1.1-.12,1.44.86,2.17,1.86,1.38,2.91.92,2.38,3.63-.48,2.47.26,1.62,2.41,2.54,1.9.82,3.15,2.87,4.69,4.15,1,.82,2.5,1.45,2.59,2.89.18,2.76-3.25,2.16-4.88,2.82-2.66,1.07-1.87,4.57.21,5.88s5.42,1.89,5.59,5c.14,2.43-1.24,3-3.12,3.77-1.5.65-1.31.84-1.31,2.63,0,3.61-1.21,4.63-4.77,4.05a9,9,0,0,0-3.44-.29c-1.36.41-.9.75-.94,1.89-.1,2.92-3.49,2.09-4.93.84C473.39,236.75,471.31,235.08,469.06,234.86Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.06,234.86a4.77,4.77,0,0,0-2.62.47,26.34,26.34,0,0,0-4.28,3,8.71,8.71,0,0,1-4.75,2,3.83,3.83,0,0,1-4-2.75,2.38,2.38,0,0,0-.22-.88,1.28,1.28,0,0,0-1.49-.39,7.81,7.81,0,0,0-1.45.84c-1.77,1-4,.8-6,.51-1.7-.25-3.83-1-3.83-2.71,0-1.11,1-1.94,1.75-2.75s1.39-2.11.69-3a2,2,0,0,0-1-.61c-2.12-.68-4.71.23-6.5-1.09a3.74,3.74,0,0,1-.93-4.48,5.67,5.67,0,0,1,3.81-2.91c1.42-.36,3.23-.53,3.76-1.89.46-1.2-.47-2.5-1.52-3.24s-2.33-1.25-3.06-2.31a3.66,3.66,0,0,1-.1-3.79,4.61,4.61,0,0,1,3.19-2.18,7.48,7.48,0,0,0,1.94-.43,1.29,1.29,0,0,0,.71-1.63c-.19-.35-.59-.53-.82-.85a1.55,1.55,0,0,1,.57-2,7.93,7.93,0,0,1,2.16-.83c1.53-.51,3-2,2.57-3.55s-2.68-2.14-3.34-3.69c-.57-1.38.34-3,1.58-3.82a28.66,28.66,0,0,1,4.07-1.82c1.35-.63,2.65-1.76,2.76-3.24s-1-2.81-2-4-1.72-2.9-.91-4.2,2.52-1.31,3.92-1.76a6.36,6.36,0,0,0,3.86-3.48c.37-.86.55-1.8,1-2.62,1.38-2.56,4.87-3.69,7.58-3.37a3.08,3.08,0,0,1,2.57,1.75,3.88,3.88,0,0,1,.94,1.77c.21,1.24-.44,2.81.72,3.76,1.78,1.44,4.5-.5,4.4,2.71a14,14,0,0,1-.6,4c-.48,1.34-1.45,1.93-.65,3.44,1.05,2,1.73,2,3.82,1.94,1.51,0,2.77-.08,3.88,1.07,1.95,2,.79,3.84-.94,5.39-2,1.77-.92,2.55-.67,4.84.13,1.1-.12,1.44.86,2.17,1.86,1.38,2.91.92,2.38,3.63-.48,2.47.26,1.62,2.41,2.54,1.9.82,3.15,2.87,4.69,4.15,1,.82,2.5,1.45,2.59,2.89.18,2.76-3.25,2.16-4.88,2.82-2.66,1.07-1.87,4.57.21,5.88s5.42,1.89,5.59,5c.14,2.43-1.24,3-3.12,3.77-1.5.65-1.31.84-1.31,2.63,0,3.61-1.21,4.63-4.77,4.05a9,9,0,0,0-3.44-.29c-1.36.41-.9.75-.94,1.89-.1,2.92-3.49,2.09-4.93.84C473.39,236.75,471.31,235.08,469.06,234.86Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,228.7c-1.62-.52-3.53-.11-5.13-.49a19.41,19.41,0,0,1,2.87-.45,8.16,8.16,0,0,1,6.21,2.46A5.62,5.62,0,0,0,444.6,234c4,1.09,8-4.32,11.86-2.67-.24,1.95,0,4.58,1.89,5a3.09,3.09,0,0,0,2.93-1.41c.7-.92,1.12-2,1.82-2.92a6.18,6.18,0,0,1,8.21-1.2c1,.76,2.34,1.9,3.38,1.15s.44-3,1.67-3.62c.82-.41,2,.24,2.66-.37a1.76,1.76,0,0,0,.47-1c.49-2.06.92-4.45-.38-6.12-1.16-1.49-3.6-2.41-3.34-4.28.23-1.59,2.26-2.08,3.86-2.26s3.63-.94,3.55-2.55-2.22-2.35-2.54-3.9c-.13-.66.09-1.4-.21-2-.46-.91-1.76-1-2.52-1.62-1.37-1.21-.31-3.48-.7-5.27-.27-1.26-1.3-2.26-1.64-3.5-.67-2.5,1.59-4.87,4-5.89a14.5,14.5,0,0,0,2.71-1.25l.08-.07a4.91,4.91,0,0,1-1.95,3.12c-2,1.77-.92,2.55-.67,4.84.13,1.1-.12,1.44.86,2.17,1.86,1.38,2.91.92,2.38,3.63-.48,2.47.26,1.62,2.41,2.54,1.9.82,3.15,2.87,4.69,4.15,1,.82,2.5,1.45,2.59,2.89.18,2.76-3.25,2.16-4.88,2.82-2.66,1.07-1.87,4.57.21,5.88s5.42,1.89,5.59,5c.14,2.43-1.24,3-3.12,3.77-1.5.65-1.31.84-1.31,2.63,0,3.61-1.21,4.63-4.77,4.05a9,9,0,0,0-3.44-.29c-1.36.41-.9.75-.94,1.89-.1,2.92-3.49,2.09-4.93.84-1.66-1.43-3.74-3.1-6-3.32a4.77,4.77,0,0,0-2.62.47,26.34,26.34,0,0,0-4.28,3,8.71,8.71,0,0,1-4.75,2,3.83,3.83,0,0,1-4-2.75,2.38,2.38,0,0,0-.22-.88,1.28,1.28,0,0,0-1.49-.39,7.81,7.81,0,0,0-1.45.84c-1.77,1-4,.8-6,.51-1.7-.25-3.83-1-3.83-2.71,0-1.11,1-1.94,1.75-2.75s1.39-2.11.69-3A2,2,0,0,0,441.9,228.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.62,205.1l-9.72,19.27V215.5l-1-37.77-1.44,37.77v6l-10.68-18.68,10.68,22.93v58.54a.6.6,0,0,0,.36.49,1.91,1.91,0,0,0,1.71,0,.6.6,0,0,0,.36-.49v-55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M470.49,288.83c-2.78.44-5.27-.32-5.7-3.33a26.63,26.63,0,0,1,0-7.46c.13-.89.44-2,1.32-2.18a1.66,1.66,0,0,1,1.79,1,4.92,4.92,0,0,1,.3,2.19c.44-1,1.1-2.1,2.17-2.12a2,2,0,0,1,1.77,2,5.8,5.8,0,0,1-.91,2.79,2.75,2.75,0,0,1,2.17.34,1.9,1.9,0,0,1,.08,2.47,5.63,5.63,0,0,1-2.18,1.56,1,1,0,0,1,1.32.65,1.49,1.49,0,0,1-.57,1.49A3.17,3.17,0,0,1,470.49,288.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-48",
    d: "M465.67,290,459,286.18a5.33,5.33,0,0,1-1.45-1.36,3.85,3.85,0,0,1-.81-1.72,1,1,0,0,1,.07-.66c.24-.35.81-.23,1.13.06a12.46,12.46,0,0,1,.9.89,10.42,10.42,0,0,1-.13-2.3,1.09,1.09,0,0,1,.28-.77.85.85,0,0,1,.93,0,3.92,3.92,0,0,1,1.54,2.45,8.08,8.08,0,0,1,.09-2.94c.23-1.05,1.43-1.46,1.84-.45a5.93,5.93,0,0,1,.36,1.67,6.84,6.84,0,0,1-.15,2.21,7,7,0,0,1,1.77-2.46,1.09,1.09,0,0,1,1-.36c.42.17.49.73.45,1.17a6.37,6.37,0,0,1-.9,2.68,5.65,5.65,0,0,1,2.24-.88.68.68,0,0,1,.71.23.9.9,0,0,1-.16.93,5.57,5.57,0,0,1-1.78,1.66,5.69,5.69,0,0,1,2.17-.23.78.78,0,0,1,.59.24c.18.28,0,.65-.28.89a6.9,6.9,0,0,1-1.55.92,2.43,2.43,0,0,1,1,.16.77.77,0,0,1,.45.79c-.06.32-.39.51-.7.62A4.67,4.67,0,0,1,465.67,290Z",
    style: {
      fill: "#438BAE"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locators--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.91,131.8a.47.47,0,0,1-.39-.19.49.49,0,0,1,.08-.7l1.18-.93a.5.5,0,0,1,.62.79l-1.18.93A.5.5,0,0,1,353.91,131.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.61,181.76a.48.48,0,0,1-.42-.23.5.5,0,0,1,.15-.69l2.5-1.6a.5.5,0,1,1,.54.84l-2.5,1.6A.47.47,0,0,1,282.61,181.76Zm6.66-4.28a.51.51,0,0,1-.42-.23.5.5,0,0,1,.15-.69l2.49-1.62a.5.5,0,0,1,.69.15.49.49,0,0,1-.15.69l-2.49,1.62A.5.5,0,0,1,289.27,177.48Zm6.63-4.33a.51.51,0,0,1-.42-.23.5.5,0,0,1,.14-.69l2.48-1.64a.5.5,0,0,1,.69.14.51.51,0,0,1-.14.7l-2.48,1.63A.46.46,0,0,1,295.9,173.15Zm6.59-4.38a.48.48,0,0,1-.41-.23.5.5,0,0,1,.13-.69l2.47-1.65a.5.5,0,1,1,.56.82l-2.47,1.66A.47.47,0,0,1,302.49,168.77Zm6.57-4.43a.5.5,0,0,1-.29-.92l2.46-1.67a.5.5,0,0,1,.56.83l-2.45,1.67A.51.51,0,0,1,309.06,164.34Zm6.52-4.48a.52.52,0,0,1-.41-.22.5.5,0,0,1,.13-.69l2.44-1.69a.5.5,0,0,1,.57.82l-2.44,1.69A.52.52,0,0,1,315.58,159.86Zm6.5-4.53a.49.49,0,0,1-.41-.21.51.51,0,0,1,.12-.7c.81-.56,1.61-1.13,2.43-1.71a.51.51,0,0,1,.69.12.5.5,0,0,1-.12.7l-2.42,1.71A.52.52,0,0,1,322.08,155.33Zm6.46-4.58a.49.49,0,0,1-.41-.21.5.5,0,0,1,.12-.7c.8-.57,1.6-1.14,2.4-1.73a.5.5,0,0,1,.7.12.51.51,0,0,1-.11.7l-2.41,1.73A.52.52,0,0,1,328.54,150.75Zm6.41-4.63a.52.52,0,0,1-.4-.21.49.49,0,0,1,.11-.7l2.39-1.75a.5.5,0,0,1,.7.1.51.51,0,0,1-.11.7L335.25,146A.57.57,0,0,1,335,146.12Zm6.37-4.7a.49.49,0,0,1-.4-.21.5.5,0,0,1,.1-.7l2.38-1.78a.51.51,0,0,1,.7.1.5.5,0,0,1-.1.7l-2.38,1.79A.54.54,0,0,1,341.32,141.42Zm6.33-4.78a.5.5,0,0,1-.4-.19.5.5,0,0,1,.09-.7l2.36-1.81a.5.5,0,1,1,.61.79c-.78.61-1.57,1.21-2.36,1.81A.49.49,0,0,1,347.65,136.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.2,185.17a.5.5,0,0,1-.26-.93l1.27-.79a.5.5,0,0,1,.53.85l-1.28.79A.5.5,0,0,1,277.2,185.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.38,79.29a.46.46,0,0,1-.23-.05c-.49-.26-.93-.48-1.32-.67a.5.5,0,1,1,.43-.9c.41.19.86.42,1.35.68a.5.5,0,0,1,.21.68A.49.49,0,0,1,322.38,79.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.46,109.3a.48.48,0,0,1-.42-.23c-.5-.79-1.06-1.6-1.66-2.4a.5.5,0,0,1,.1-.7.49.49,0,0,1,.7.1c.61.82,1.19,1.65,1.7,2.46a.5.5,0,0,1-.15.69A.53.53,0,0,1,358.46,109.3Zm-4.82-6.24a.49.49,0,0,1-.37-.16c-.65-.72-1.32-1.43-2-2.14a.5.5,0,1,1,.71-.7c.71.72,1.39,1.44,2,2.17a.5.5,0,0,1,0,.71A.54.54,0,0,1,353.64,103.06Zm-5.58-5.57a.46.46,0,0,1-.33-.13c-.73-.66-1.46-1.31-2.21-2a.51.51,0,0,1,0-.71.51.51,0,0,1,.71,0c.75.65,1.49,1.31,2.22,2a.5.5,0,0,1,0,.71A.49.49,0,0,1,348.06,97.49Zm-6-5.1a.45.45,0,0,1-.31-.11c-.78-.61-1.55-1.21-2.33-1.8a.5.5,0,1,1,.6-.8c.79.59,1.57,1.2,2.35,1.82a.5.5,0,0,1,.08.7A.48.48,0,0,1,342.05,92.39Zm-6.32-4.72a.46.46,0,0,1-.29-.1c-.81-.57-1.62-1.14-2.42-1.68a.5.5,0,1,1,.56-.82c.8.54,1.62,1.1,2.44,1.69a.5.5,0,0,1,.12.7A.52.52,0,0,1,335.73,87.67Zm-6.55-4.39a.56.56,0,0,1-.27-.08c-.87-.55-1.71-1.07-2.51-1.55a.5.5,0,1,1,.52-.85c.8.48,1.65,1,2.53,1.55a.5.5,0,0,1,.15.69A.48.48,0,0,1,329.18,83.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.25,115.05a.5.5,0,0,1-.48-.35c-.14-.45-.31-.91-.49-1.37a.5.5,0,1,1,.92-.37c.2.48.37,1,.53,1.44a.51.51,0,0,1-.33.63Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Pin--inject-48",
    d: "M327.14,59.4a10.16,10.16,0,1,0-20.31,0v1.32c0,4.45,6.23,12.82,8.79,16a1.69,1.69,0,0,0,2.53.06c2.89-3.35,9-11.28,9-16.07ZM317,63.66a4.91,4.91,0,1,1,5.08-4.91A5,5,0,0,1,317,63.66Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--pin--inject-48",
    d: "M362.88,115.61a6.74,6.74,0,1,0-13.47,0v.87c0,3,4,8.32,5.83,10.62a1.12,1.12,0,0,0,1.75.08c1.85-2.35,5.89-7.52,5.89-10.7Zm-6.74,2.83a3.26,3.26,0,1,1,3.37-3.26A3.32,3.32,0,0,1,356.14,118.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--pin--inject-48",
    d: "M319.85,145.1a5.56,5.56,0,1,0-11.12,0v.72c0,2.44,3.47,7.35,4.82,8.77a.85.85,0,0,0,1.36,0c1.38-1.55,4.94-6.15,4.94-8.78Zm-5.56,2.34a2.69,2.69,0,1,1,2.78-2.69A2.74,2.74,0,0,1,314.29,147.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--pin--inject-48",
    d: "M281.26,171.81a4.06,4.06,0,1,0-8.12,0v.52c0,1.79,2.41,5,3.52,6.41a.58.58,0,0,0,1,0c1.05-1.23,3.64-4.49,3.64-6.41Zm-4.06,1.7a2,2,0,1,1,2-2A2,2,0,0,1,277.2,173.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--pin--inject-48",
    d: "M336.32,198.47a4.07,4.07,0,1,0-8.13,0V199c0,1.79,2.41,5,3.52,6.41.27.34.71.48.87.28.95-1.17,3.74-4.77,3.74-6.69Zm-4.06,1.7a2,2,0,1,1,2-2A2,2,0,0,1,332.26,200.17Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocks-1--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-48",
    d: "M265.14,444.59,272.3,450,244,475.23l-43.94,3.62-44.25-7.43-39.43,8.75L89.17,455.42l-40.61-3.37L19,429.19l23.39-28.63s96.15-4,96.26-3.69,59,27.71,59,27.71l52.15,9.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boulder--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--grass--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6,362.82c2,10-.62,22.78-.62,22.78l2.15-1.25C49.65,370.28,46.6,362.82,46.6,362.82Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6,362.82c2,10-.62,22.78-.62,22.78l2.15-1.25C49.65,370.28,46.6,362.82,46.6,362.82Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.09,384.86s0,.07,0,.11l1.06-.62c1.52-14.07-1.53-21.53-1.53-21.53C48.29,367.67,48.18,379.39,47.09,384.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,385.6a64.15,64.15,0,0,0-4.32-16.93c-3.43-7.84-7.74-11.34-7.74-11.34s5.27,2.41,9.59,10.83A54.1,54.1,0,0,1,48.81,384Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,385.6a64.15,64.15,0,0,0-4.32-16.93c-3.43-7.84-7.74-11.34-7.74-11.34s5.27,2.41,9.59,10.83A54.1,54.1,0,0,1,48.81,384Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.46,384.74h0l1.35-.77a54.1,54.1,0,0,0-5.3-15.81c-4.32-8.42-9.59-10.83-9.59-10.83C39.06,360.64,45.91,371.49,47.46,384.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,385.6s-1.51-7.48-10.79-13.71a26,26,0,0,1,12.94,12.46Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.09,384.86l0,.08,1-.59a26,26,0,0,0-12.94-12.46C39.5,374.39,44.76,378.63,47.09,384.86Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--grass--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.85,406.32c-1.58,8.08.5,18.36.5,18.36l-1.74-1C239.38,412.33,241.85,406.32,241.85,406.32Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85,406.32c-1.58,8.08.5,18.36.5,18.36l-1.74-1C239.38,412.33,241.85,406.32,241.85,406.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,424.08s0,.06,0,.09l-.86-.5c-1.23-11.34,1.24-17.35,1.24-17.35C240.48,410.23,240.57,419.67,241.45,424.08Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,424.68A51.44,51.44,0,0,1,245.83,411c2.76-6.31,6.24-9.13,6.24-9.13s-4.26,1.93-7.74,8.72a43.44,43.44,0,0,0-4.26,12.74Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,424.68A51.44,51.44,0,0,1,245.83,411c2.76-6.31,6.24-9.13,6.24-9.13s-4.26,1.93-7.74,8.72a43.44,43.44,0,0,0-4.26,12.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.15,424h0l-1.08-.63a43.44,43.44,0,0,1,4.26-12.74c3.48-6.79,7.74-8.72,7.74-8.72C247.92,404.56,242.4,413.31,241.15,424Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,424.68s1.21-6,8.69-11.05a21,21,0,0,0-10.43,10Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,424.08l0,.07-.81-.48a21,21,0,0,1,10.43-10C247.57,415.64,243.33,419.06,241.45,424.08Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.39,438.21l.92,11L237,471.56l-39.18,2.12-44.25-7.79-27.77,8.83S95,452,94,451.37s-43.28-9.92-43.28-9.92l-22.7-16.77,12.52-36.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.55 465.89 149.86 447.69 130.85 444.94 125.78 474.72 153.55 465.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.78 474.72 130.85 444.94 106.27 404.13 94.04 451.37 125.78 474.72",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.99 471.56 197.8 473.68 195.86 424.68 225.65 431.51 236.99 471.56",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.8 473.68 152.32 459.83 153.55 465.89 197.8 473.68",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.39 438.21 236.99 471.56 264.31 449.18 263.39 438.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.76 441.45 63.52 394.32 78.81 397.83 85.23 449.18 50.76 441.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.76 441.45 63.52 394.32 40.58 387.83 28.06 424.68 50.76 441.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,437.9c-3.38-6-6.22-8.14-10.54-11.55,0,0-24.72-7.2-25.46-7.6S172.45,408,172.45,408l-64.89-31.77H59.13c-9.83,2.39-18.87,7.6-20.36,9.46l-.36,2.55,5.54,9,17.31,6.73L80.15,414l21.2,10.34,28.42,27.43h20l47,8.93,38.11-4.24c12.69-5.69,25.78-11.42,30.06-16Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,437.9c-3.38-6-6.22-8.14-10.54-11.55,0,0-24.72-7.2-25.46-7.6S172.45,408,172.45,408l-64.89-31.77H59.13c-9.83,2.39-18.87,7.6-20.36,9.46l-.36,2.55,5.54,9,17.31,6.73L80.15,414l21.2,10.34,28.42,27.43h20l47,8.93,38.11-4.24c12.69-5.69,25.78-11.42,30.06-16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.95 403.79 61.62 401.35 80.51 411.42 80.91 414.35 60.95 403.79",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.62 401.35 44.31 394.63 38.77 385.64 38.41 388.19 43.95 397.19 60.95 403.79 61.62 401.35",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.95 397.19 44.31 394.63 38.77 385.64 38.41 388.19 43.95 397.19",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.71 421.75 101.35 424.31 129.77 451.74 130.13 449.18 101.71 421.75",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.8 451.74 150.16 449.18 130.13 449.18 129.77 451.74 149.8 451.74",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.82 460.67 197.18 458.11 235.29 453.87 234.93 456.43 196.82 460.67",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13,376.18c-9.83,2.39-18.87,7.6-20.36,9.46l5.54,9,17.31,6.72,18.89,10.07,21.2,10.33,28.42,27.43h20l47,8.93,38.11-4.24c12.68-5.68,25.77-11.42,30-16-3.38-6-6.22-8.14-10.54-11.55,0,0-24.72-7.2-25.46-7.6S172.45,408,172.45,408l-64.89-31.77Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13,376.18c-9.83,2.39-18.87,7.6-20.36,9.46l5.54,9,17.31,6.72,18.89,10.07,21.2,10.33,28.42,27.43h20l47,8.93,38.11-4.24c12.68-5.68,25.77-11.42,30-16-3.38-6-6.22-8.14-10.54-11.55,0,0-24.72-7.2-25.46-7.6S172.45,408,172.45,408l-64.89-31.77Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.23 431.07 236.72 441.45 211.39 441.52 180 447.69 144.38 439.38 122.48 420.95 152.56 404.69 205.39 360.8 212.35 378.42 221.09 378.75 223.05 392.88 234.61 405.22 236.99 418.76 251.23 431.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.39 360.8 212.35 378.42 193.93 370.32 205.39 360.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.72 441.45 236.99 418.76 234.61 405.22 211.39 441.52 236.72 441.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.05 392.88 223.05 406.31 213.95 420.18 211.39 441.52 205.04 413.94 218.8 403.79 223.05 392.88",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.04 413.94 193.68 435.67 180 447.69 211.39 441.52 205.04 413.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.68 435.67 175.06 426 144.38 439.38 180 447.69 193.68 435.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.04 413.94 211.39 399.38 208.22 392.24 185.79 403.09 193.68 435.67 205.04 413.94",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.38 439.38 150.16 405.99 122.48 420.95 144.38 439.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.06 426 170.98 404.84 150.16 405.99 144.38 439.38 175.06 426",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.06 426 159.72 442.96 144.38 439.38 175.06 426",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,378.75s-7.74-6.47-21.68-10.21l6.43-4.28-.71-2.42s-6.52-3.93-21.7-7.15L175.06,371l-26.12,7.38-14.27,13-22.22-.85,10,30.39h0l27.65-8.28h22.6l16,1.86,28.09-17.79,8.13-15.57Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,378.75s-7.74-6.47-21.68-10.21l6.43-4.28-.71-2.42s-6.52-3.93-21.7-7.15L175.06,371l-26.12,7.38-14.27,13-22.22-.85,1.24,3.76L122.48,421h0l27.65-8.28h22.6l16,1.86,28.09-17.79,8.13-15.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.23 361.84 208.94 364.26 202.51 368.55 199.34 367.77 208.23 361.84",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.33,367.77l8.9-5.93s-6.52-3.93-21.7-7.15L175.06,371l-26.12,7.38-14.27,13-21,2.91L122.48,421l26.94-10.71H172L188,412.11l28.09-17.79,8.13-15.57S215.27,371.29,199.33,367.77Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.33,367.77l8.9-5.93s-6.52-3.93-21.7-7.15L175.06,371l-26.12,7.38-14.27,13-21,2.91L122.48,421l26.94-10.71H172L188,412.11l28.09-17.79,8.13-15.57S215.27,371.29,199.33,367.77Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.06 394.32 216.76 396.74 188.68 414.53 187.97 412.11 216.06 394.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.13 412.67 149.42 410.25 122.48 420.95 150.13 412.67",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.68,401.15l23.9-1.53-7.52-8.48-27.5-13.46H59.13c-2,.48-3.89,1.07-5.73,1.72l-3,11.27,15.17,8.85,22.63,8.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.58 358.54 200.58 358.55 187.74 376.82 158.54 385.08 142.58 399.62 117.72 398.67 88.84 404.31 54.11 388.32 63.26 335.14 180.62 324.34 185.44 343.87 195.11 346.06 200.58 358.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.58 399.62 121.81 371.51 120.21 350.84 111.83 380.02 117.72 398.67 142.58 399.62",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.18 385.45 88.84 404.32 66.98 395.6 65.54 370.29 75.34 352.69 101.69 366.12 94.18 385.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.12 388.32 66.98 395.6 65.54 370.29 75.34 353.68 63.26 335.14 54.12 388.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.72 398.67 111.83 380.02 120.21 350.84 101.69 366.12 94.18 385.45 88.84 404.32 117.72 398.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.69 357.94 181.75 351.24 185.44 343.87 180.62 324.34 170.59 337.1 172.69 357.94",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.54 385.08 172.69 357.94 170.59 337.1 159.87 343.74 158.54 385.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.69 357.94 178.01 367.69 200.58 358.54 195.12 346.06 172.69 357.94",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.75 376.83 178.01 367.69 200.58 358.54 187.75 376.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--grass--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.27,379.86c-.72,9.18,2.9,19.17,2.9,19.17h-2.06C122.3,386.58,124.27,379.86,124.27,379.86Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.27,379.86c-.72,9.18,2.9,19.17,2.9,19.17h-2.06C122.3,386.58,124.27,379.86,124.27,379.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,399s0,0,0,0h-1c-2.81-12.45-.84-19.17-.84-19.17C123.26,384.38,124.56,394.24,126.09,399Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,399a51.88,51.88,0,0,1,2.12-14.44c2.27-7.37,5.77-10.95,5.77-10.95s-4.48,2.7-7.48,10.68A48.69,48.69,0,0,0,124.47,399Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,399a51.88,51.88,0,0,1,2.12-14.44c2.27-7.37,5.77-10.95,5.77-10.95s-4.48,2.7-7.48,10.68A48.69,48.69,0,0,0,124.47,399Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75,399h-1.28a48.69,48.69,0,0,1,3.11-14.71c3-8,7.48-10.68,7.48-10.68C130.8,377.14,125.77,387,125.75,399Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.17,399s.58-5.68,8.25-12.21A22.16,22.16,0,0,0,125.11,399Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,399s0,0,0,0h-1a22.16,22.16,0,0,1,10.31-12.21C131.81,389.49,127.54,393.21,126.09,399Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,323.22a188.64,188.64,0,0,0-19.78-10L134.09,307,82.46,313.8S68.06,323,60.88,334.91v2.93l10.94,17.5,29.87,10.78,32.84-11.62,24.91-1.17,19.35-10.58v-2.93l-1.39-5.15,7.89-8.52Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,323.22a188.64,188.64,0,0,0-19.78-10L134.09,307,82.46,313.8S68.06,323,60.88,334.91v2.93l10.94,17.5,29.87,10.78,32.84-11.62,24.91-1.17,19.35-10.58v-2.93l-1.39-5.15,7.89-8.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88,334.91l10.94,17.5,29.87,10.77,32.84-11.61,24.91-1.17,19.35-10.58-2.08-7.55,8.58-9a188.64,188.64,0,0,0-19.78-10L134.09,307,82.46,313.8S68.06,323,60.88,334.91Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88,334.91l10.94,17.5,29.87,10.77,32.84-11.61,24.91-1.17,19.35-10.58-2.08-7.55,8.58-9a188.64,188.64,0,0,0-19.78-10L134.09,307,82.46,313.8S68.06,323,60.88,334.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.29 323.22 176.71 332.27 177.4 334.67 185.29 326.15 185.29 323.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.44 353.33 159.44 350.4 134.53 351.57 134.53 354.5 159.44 353.33",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.53 351.57 101.69 363.19 101.69 366.12 134.53 354.5 134.53 351.57",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.82 355.34 71.82 352.41 60.88 334.91 60.88 337.84 71.82 355.34",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.76 347.45 192.79 343.74 185.44 343.87 181.75 351.24 172.69 357.94 199.06 352.45 197.76 347.45",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.76 347.45 199.06 352.45 172.69 357.94 189.22 351.02 197.76 347.45",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.44 343.87 181.75 351.24 172.69 357.94 193.27 350.84 197.76 347.45 192.79 343.74 185.44 343.87",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.44 343.87 181.75 351.24 172.69 357.94 193.27 350.84 197.76 347.45 192.79 343.74 185.44 343.87",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-48",
    d: "M80.25,323.55c-13.78,6.73-15.33,13.37-3,19.42s39.19,4.37,52.52,3.91c13.5-.47,21.55-1.33,27.54-2.3,6.62-1.06,22.31-6.83,14.82-11.09-8.62-4.91-29.22-1.2-43.25-3.86s-13.73-7.21-23.11-9.24A39.35,39.35,0,0,0,80.25,323.55Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-48"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.5,313.26c-2.21-1.57-4-2.18-4.33-1s.34,4.76.34,4.76l1.17,3.25.17,2.93s.73,1.75.77,1.88,2.2-4.81,2.2-4.81S153.58,314.83,150.5,313.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.58,309.27s13-21.29,19.57-34c4.85-9.38,5.25-11.17,6.27-17.21,2.19-13,2.71-16,2.71-16l5.28,25.79c-.53,2.85-1.62,8.49-1.53,11.78a124.81,124.81,0,0,0,2.45,19.07,198.62,198.62,0,0,0,5,21c1.06.66,4.07.66,6.67.47a31.69,31.69,0,0,0,7.41-1.7s.8-30.71.94-39.15c.15-10.13.19-14.11.27-19.67.12-8.86.78-21.71-.29-37.93-2.14-32.27-10.15-46.69-10.15-46.69l-37.52-3.4c-2.61,11-9,12.57-9,27.45,0,3.38,2.11,10,2.41,15.22,1,17,3.69,43.55,3.69,43.55-3.93,3.87-6.78,7.34-9.23,16C87,279.18,82.37,296,81,300.71,86.74,302,93.58,309.27,93.58,309.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87,194.22l-1-.1c-.61,5.89-1.74,12.59-2.51,13.15-1.32,1-6.37,1.94-7.52,1.71s-2.2-1.09-4.34-3.69c-1.51-1.82-1.41-3-1.19-5.6.09-1,.18-2.07.21-3.45l-1,0c0,1.35-.12,2.43-.2,3.39-.22,2.61-.36,4.18,1.41,6.32,2.32,2.81,3.47,3.75,4.93,4a3.69,3.69,0,0,0,.63,0c2,0,6.35-1,7.66-1.93C125.45,207,126.57,197.2,126.87,194.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.83,194.83l-1,.31c3.26,9.8,2.32,16.76-2.61,19.74A212.63,212.63,0,0,0,134.33,194l-1,.27c6.81,23.6,8.34,42.35,8.6,65,.2,17.22.4,46.84.49,60.58l1-.21c-.09-13.83-.29-43.25-.49-60.39-.17-15.3-.94-28.86-3.51-43.33C145.12,212.8,146.33,205.33,142.83,194.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.29,203.81A5.47,5.47,0,0,0,94.53,205h0c1.58,0,4.09-2.3,4.76-4a11,11,0,0,0,.49-3,25.83,25.83,0,0,1,.64-4.48l-1-.23a27.06,27.06,0,0,0-.67,4.63,10.6,10.6,0,0,1-.42,2.74C97.82,202,95.62,204,94.57,204h0A8,8,0,0,1,92,202.16C92.06,202.65,92.19,203.32,92.29,203.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.85,215c.48,13.31-1.11,38.17-2.35,45.62-1,6.38-16.13,35.06-21,44.14l.8.63c4.78-8.95,20.06-37.95,21.16-44.61,1.24-7.48,2.84-32.45,2.36-45.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38,191.29c-2.36,4.05-3.59,11,0,18.44l.9-.43c-3.43-7.08-2.27-13.68-.05-17.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,242.05,116.87,215s-10.55-1-12.43-10.52c0,5.72,2.55,10.52,9.18,12.87l6.32,24.9-.52,15.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,333.17c.62-.1.67,2.23.5,3s-2.53,3.48-7,4.68-11.39.6-14.07.66-5.21,1.45-8.91,2.15c-3.3.62-7.84.05-9.49-1.35a3,3,0,0,1-.79-2.43c-.06-1.72.08-2.08.28-2.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.33,334a15,15,0,0,0,.25,5c.64,1.25,2.41,1.85,3.63,2.13,3.24.73,5.64.4,9.09-.5a26.85,26.85,0,0,1,6.84-1.15c2.77,0,6.6.21,9.34-.24a23,23,0,0,0,6.75-1.87c1.78-.9,3.5-2,3.89-3.88a6.06,6.06,0,0,0-3.93-5.78c-2.08-1-4.71-.87-7-.93-2.88-.07-3.95.17-6.88-.44-1.54-.32-3.67.42-4.47-1.22-.95-1.94-.45-5.73-.86-7.8a1.23,1.23,0,0,0-.48-.88c-.44-.24-1,.08-1.36.38a14.24,14.24,0,0,1-6.24,2.49c-6.17,1.1-8-1-8-1l-.37-1.28s-1.34.29-.71,3.2a40.1,40.1,0,0,1,1,7.29A24.23,24.23,0,0,1,132.33,334Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.08,326.76c2.24.89,1.79,4.79,1.79,4.79a20.52,20.52,0,0,1-7.26.24c-4.16-.84-6-3.54-6.09-6.92s2.08-7.49,2.66-8.85a2.1,2.1,0,0,0-.68-2.76c2,1.2,2.15,2.56,1.59,4.2s-1.47,5-1.05,6.29S154.81,326.57,160.08,326.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.93,308c1.23,1.76,2.61,3-.92,5.31-2.72,1.78-2.9,3.22-3.76,5.13s-.71,5.76-.71,5.76-4.6-7.08-3.21-11.6S93.93,308,93.93,308Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,303.82c-.88,1.26-2.91,2.33-4.59,3.36-1.19.72-2.41,1.43-2.77,2.77,0,.15.69,1,.67,1.15a7.74,7.74,0,0,0,.06,2c.25,2.29,1.49,4,1.74,6.28a16.12,16.12,0,0,0,.48,2.69,16.11,16.11,0,0,1,.24,3.26c.06,1.14.13,2.29.18,3.43A6.49,6.49,0,0,1,75,330.2c-.11.48,7.62,4.44,10.73,6,.18.09.36.16.56.24a8.11,8.11,0,0,0,5.71-.52c6.25-2.21,5.88-4.47,5.88-4.47s.21-2.6-2.94-4.38a6.25,6.25,0,0,0-1.18-.55l-.06,0a8.12,8.12,0,0,0-4.84-.29,8.36,8.36,0,0,1-.4-2.87,30.49,30.49,0,0,1,0-4.38,11.32,11.32,0,0,1,1.91-4.59c1.33-1.82,2.78-4.11,3.69-5.42,1-1.12,1.15-4.35-4-8.1-4.94-3.58-8.59-2.87-9.3-1.39A20.38,20.38,0,0,1,79,303.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,328.45A4.63,4.63,0,0,0,90,326a7.35,7.35,0,0,0-1.1.19C89.52,326.79,91.76,327.67,92.18,328.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.86,311.28c-1.39.57,0,4.34,1.06,7.92S73.45,324,73.1,327s-.57,4.38.73,5.44,11.5,5.27,11.5,5.27a35.06,35.06,0,0,1-2.62-11.21c-.48-6.64-1.09-10.91-4.37-13.83A8,8,0,0,0,70.86,311.28Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.86,311.28c-1.39.57,0,4.34,1.06,7.92S73.45,324,73.1,327s-.57,4.38.73,5.44,11.5,5.27,11.5,5.27a35.06,35.06,0,0,1-2.62-11.21c-.48-6.64-1.09-10.91-4.37-13.83A8,8,0,0,0,70.86,311.28Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.92,331.41c-.17,1.29-3.89,3.9-8.27,3.82s-4.74-1-5.39-6.15S83.2,316.83,81,313.76s-5.1-4.89-9.38-3.81c-.49.23-1.82,1.54-1.33,2.78,0,0,0-1,1.75-1.47,1.5-.42,3.29-.36,5.78,1.81,2.91,2.55,3.52,8.47,3.82,13.56s.72,11,4.93,11.46a15.59,15.59,0,0,0,11.29-3.74A6.1,6.1,0,0,0,97.92,331.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106,121.57c-5.77,0-11.92,1.68-18.35,11.39a110.18,110.18,0,0,0-11.77,23.4c-1.31,3.85-4.48,10.55-1.75,13.12s16.3,1.39,21.52-3.45,7.51-25.45,7.51-25.45Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.38,137.15c5.19-2.78.23-11.1-3.76-19-6.47-12.75-12.51-22.12-16.09-26.09-1.83-2-6.32-4.67-9.92-6.27-1.85-.83-2.86-1.54-4.78-1.52-2.22,0-4.63-.2-7.59-.27a48.34,48.34,0,0,0-7.12,0,1.43,1.43,0,0,0-1,.42,1,1,0,0,0,0,1,2.31,2.31,0,0,0,.74.75,7.47,7.47,0,0,0,1.9,1,1.91,1.91,0,0,0-1,1.55c0,.88,1,1.4,1.76,1.82a.54.54,0,0,1,.23.22.57.57,0,0,1,0,.38,1.77,1.77,0,0,0,.6,1.8,4.79,4.79,0,0,0,1.77.9c2.42.81,5.42.59,7.61,1.91a19,19,0,0,1,2.86,2.82,10.38,10.38,0,0,0,3.83,2.58c3.53,1.15,4-.44,5.79,3.43s7.34,23.81,7.34,23.81Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,89.49c.06.34-.3.59-.61.64a3.3,3.3,0,0,1-.94,0,10.62,10.62,0,0,1-1.86-.31c-1.22-.31-2.36-.79-3.53-1a8,8,0,0,0-1.74-.18,2.85,2.85,0,0,0-.81.1,1.18,1.18,0,0,0-.58.34c-.26.27-.15.7.17,1.13a5.76,5.76,0,0,0,1.26,1.14,12.72,12.72,0,0,0,3.3,1.32,6.67,6.67,0,0,1,1.79.79A4,4,0,0,1,148.42,95c.29.59.44,1.21.67,1.75a5.68,5.68,0,0,0,.91,1.51,8,8,0,0,0,3,2,7.43,7.43,0,0,1-3.31-1.72A5.79,5.79,0,0,1,148.57,97c-.29-.58-.47-1.16-.76-1.66a3.31,3.31,0,0,0-1.1-1.24,5.75,5.75,0,0,0-1.6-.63,12.11,12.11,0,0,1-3.56-1.37,6.45,6.45,0,0,1-1.47-1.35,2.56,2.56,0,0,1-.46-1,1.48,1.48,0,0,1,.36-1.22,2.61,2.61,0,0,1,2-.66,7.19,7.19,0,0,1,1.92.29c1.23.34,2.35.88,3.5,1.27a10.63,10.63,0,0,0,1.75.51,3.34,3.34,0,0,0,.89.06A.56.56,0,0,0,150.7,89.49Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.1,88.35a5.76,5.76,0,0,0,.35-5.73c-.79-1.82-2.37-3.71-6.85-5.81-5.33-2.51-19.77-3.88-26.51,5.78-1,1.4,14.17,27.42,13.69,33,3.51-4,15.1-18,15.1-18,2.82-1.33,4.51-2.43,5-5.16A6.72,6.72,0,0,0,139.1,88.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.23,96s4.11,6.18,3.71,6.71a20.32,20.32,0,0,1-2.8,2Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,84.61c2.65,1.12,5,3,6,8.7.27,1.48-.82,3.56-.21,5.52,2.58,8.4.17,15.58-1.42,17.2-1.08,1.1-6.89,1.79-10,1.06-3.86-.92-12.32-4.36-16.51-10.19-4.93-6.85-6.38-16.27-1.33-20.27C115.63,81,129.16,83.4,132,84.61Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.55,111.6l-.92,10.15h0c-2.29.71-1.89,3.93-.54,5.91l-.27,3L125.75,132,128,114.85Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.05,116.26c-1.33.8-4.3,1.47-8.38,1.06l.25-2.1a22.15,22.15,0,0,0,3.91,1A14.45,14.45,0,0,0,136.05,116.26Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.94,87.5c.28,3.69-2,4.94-3.61,5.73a8,8,0,0,1,.84,4.33c-.29,1.89-.95,3.45-2.77,4.14-1.11.43-1.46-.06-1.9-.93-.62-1.25-1.41-3.16-4.11-2.68-3.1.54-3.74,5.26-1.81,8.27a4.58,4.58,0,0,0,3.6,2.23,2.86,2.86,0,0,0,2.08-1.09s0,4.11-5.22,6.73c0,0-5.2,3.2-10.7,1.79a102.68,102.68,0,0,1-7.26-8.26C99,99.68,97.3,84.53,107,81.43c.46-.15,9.28-1.72,13.63-1C134,82.85,135.89,86.86,135.94,87.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26,107.5c0,4.56-1.9,9.25-5.9,11.7a11.4,11.4,0,0,1-7.75,1.73c-2.94-.43-5.76-1.6-8.75-1.68-6.15-.16-11.7,4.49-17.84,4.12a14.28,14.28,0,0,1-8.77-4.13c-2-1.91-3.66-4.28-6.1-5.56s-5.46-1.3-8.22-1.93A17.79,17.79,0,0,1,55.45,106a12.13,12.13,0,0,1-3.08-7,7.15,7.15,0,0,1,3.53-6.32c1.89-1.17,4.76-1.59,6.64-2.78,2.11-1.32,2.38-3.8,4.25-5.45a11.89,11.89,0,0,1,6.7-2.55,21.92,21.92,0,0,1,9.37,1.13c3.39,1.21,6.69,3.3,10.28,3,3.35-.3,6.14-2.47,8.67-4.48,3.44-2.71,6.49-3.82,9-3.46.14,0-.32,27.88,8.17,31.07S128.26,107.5,128.26,107.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,129.12c1.72-4.68,12.87-7.61,12.18-7.66,1.53.12,3.34.29,3.34.29-.93,1.85.41,3.16,2.82,3.85,3.12.9,7.91,1.23,11.28-.77l1-.67a79.53,79.53,0,0,1,8.67,1.73c5.27,2,6.59,3.79,12.06,18,2.33,6.07.89,12.36-5.41,15.8-.47,3.75-1,9.65-1,9.65a215.39,215.39,0,0,1,3.82,24.4s-3.32,7.53-26.31,6.26c-17.79-1-26.08-10-26.08-10,.44-4.37,3.2-11.34,8.87-24.5C94.7,146.57,93.65,135.82,96.11,129.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.63,121.75s-7.45,3.3-8.95,8.06l-7-.88s4.8-5.74,10.71-7.47C110.35,121.07,111.63,121.75,111.63,121.75Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.63,121.75s-7.45,3.3-8.95,8.06l-7-.88s4.8-5.74,10.71-7.47C110.07,121.07,111.63,121.75,111.63,121.75Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.78,136.62s3.33-9.56,7.67-10.73a31.27,31.27,0,0,0-8.23-1.58,20.76,20.76,0,0,0-6.67,8.18Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.78,136.62s3.33-9.56,7.67-10.73a31.27,31.27,0,0,0-8.23-1.58,20.76,20.76,0,0,0-6.67,8.18Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Backpack--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.87,124.1c-4.26-.32-10.82,3.91-12.39,7.13-1.65,3.38-8.38,50-4.86,54.6C87,191.6,109.17,203.7,119,204a16.34,16.34,0,0,0,14.07-7.32c2.1-3.42.7-51.89-1.77-56.11C127.28,133.69,105.29,124.51,99.87,124.1Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,124.1c-4.26-.32-10.82,3.91-12.39,7.13-1.65,3.38-8.38,50-4.86,54.6C87,191.6,109.17,203.7,119,204a16.34,16.34,0,0,0,14.07-7.32c2.1-3.42.7-51.89-1.77-56.11C127.28,133.69,105.29,124.51,99.87,124.1Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.77,165.22c-.08-2-.17-4-.28-6,0-.78-.08-1.54-.13-2.3-.09-1.5-.19-3-.29-4.33,0-.69-.11-1.36-.16-2-.09-1-.17-1.9-.26-2.77s-.19-1.68-.29-2.42c0-.25-.06-.49-.1-.72a14.34,14.34,0,0,0-1-4.16,4.91,4.91,0,0,0-.39-.58,2.43,2.43,0,0,0-.14-.2l-.32-.4-.2-.23c-.11-.13-.23-.25-.35-.38l-.23-.24-.57-.54-.39-.36-.28-.23L128,137l-.23-.18-.54-.42c-3.86,1.36-4.31,1.14-4.42,1.21s-4.18,2.24-4.13,8.18l-.54,24-.06,2.28c0,3.18-3.46,32.39,5.59,31.23l.36,0c6.11-1.79,8-5,9.07-6.61a5.35,5.35,0,0,0,.43-1.58c0-.31.09-.66.14-1q0-.28.06-.6c.06-.62.11-1.32.15-2.08,0-.26,0-.52,0-.79.2-4,.24-9.6.14-15.59,0-1.19,0-2.41-.07-3.63,0-.81,0-1.63-.07-2.44,0-.41,0-.82,0-1.23C133.83,166.84,133.8,166,133.77,165.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,143.25a10,10,0,0,0-.75-2.72c-4-6.84-26-16-31.42-16.43-4.26-.32-10.82,3.91-12.39,7.13a25,25,0,0,0-1.06,4.26c8.4,5,30.13,16.28,32.41,15.59,2.79-.84,13-7.45,13.2-7.82Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,177.57c-4.46-2.37-14.37-8.64-17.13-10.08a3.09,3.09,0,0,0-3.09-.18c-.4.26-1.8,1.16-2.17,1.36a2,2,0,0,0-1,1.67c-.17,5.07-.34,7.15-.17,9.61.11,1.68.39,3.18,2.8,5.08s12.89,8.14,16,9.83c2.92,1.58,6,2.81,7.34,1.94.34-.23,1.86-1.14,2.26-1.4a1.59,1.59,0,0,0,.61-1.39c0-2.6.21-8.14.27-10C114.13,181.65,113,180.07,108.33,177.57Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.33,177.57c-4.46-2.37-14.37-8.64-17.13-10.08a3.09,3.09,0,0,0-3.09-.18c-.4.26-1.8,1.16-2.17,1.36a2,2,0,0,0-1,1.67c-.17,5.07-.34,7.15-.17,9.61.11,1.68.39,3.18,2.8,5.08s12.89,8.14,16,9.83c2.92,1.58,6,2.81,7.34,1.94.34-.23,1.86-1.14,2.26-1.4a1.59,1.59,0,0,0,.61-1.39c0-2.6.21-8.14.27-10C114.13,181.65,113,180.07,108.33,177.57Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41,183.26l2.29-1.3c-.61-1.39-2.14-2.68-5.37-4.39-4.46-2.37-14.37-8.64-17.13-10.08a3.09,3.09,0,0,0-3.09-.18c-.4.26-1.8,1.16-2.17,1.36a2,2,0,0,0-.91,1.16Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,170.34c-.17,5.07-.34,7.15-.17,9.61.11,1.68.39,3.18,2.8,5.08s12.89,8.14,16,9.83c3.8,2.06,8,3.53,8,.55,0-2.6.21-8.13.27-10,.07-2.33-1-3.92-5.73-6.42-4.46-2.36-14.38-8.63-17.13-10.08C86.63,167.67,85,168.82,85,170.34Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,170.34c-.17,5.07-.34,7.15-.17,9.61.11,1.68.39,3.18,2.8,5.08s12.89,8.14,16,9.83c3.8,2.06,8,3.53,8,.55,0-2.6.21-8.13.27-10,.07-2.33-1-3.92-5.73-6.42-4.46-2.36-14.38-8.63-17.13-10.08C86.63,167.67,85,168.82,85,170.34Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,182c-.49-1.34-2.69-.46-3.15,1.3s-.37,4.1-.6,4.87-24.72-13.54-25.4-14.35c-.31-.37-.09-4.64.77-5.4s2.85-2.09,4.19-1.8,16.21,9.06,19.11,10.61S113.81,180.3,113.7,182Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,182c-.49-1.34-2.69-.46-3.15,1.3s-.37,4.1-.6,4.87-24.72-13.54-25.4-14.35c-.31-.37-.09-4.64.77-5.4s2.85-2.09,4.19-1.8,16.21,9.06,19.11,10.61S113.81,180.3,113.7,182Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32,168.38c-.73.59-1.07,3.23-1.14,5.49s7.9,10.39,10.53,11.66,15.27,4.25,15.41,2.78.11-4.81.72-5.74c.14-.22-8.55-4.67-13.61-7.32S86,167.88,85.32,168.38Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.79,180.73a2.12,2.12,0,0,1,1,1.89.8.8,0,0,1-1.23.73,2.11,2.11,0,0,1-1-1.89C94.62,180.72,95.17,180.4,95.79,180.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,157c.44-3.69.68-6.21,1.19-9.29,1.17-.85,2.8-1.91,2.8-1.91l10.48,3.64,9.81,3.41,2.23.77c.69.25,1.4.68,2.09.87,1.79.48,4.38-1,5.69-2s2.11-2,3.8-2.35q-.19,5-.46,10.05c-.17,3.15-.11,6.34-1.09,9.33a4.64,4.64,0,0,1-3.29,3.12,14.07,14.07,0,0,1-5.67,0s-.17,2.83-.44,4.22a4,4,0,0,1-2.44,2.18c-1.64-.43-1.91-8.09-1.91-8.09l-12.52-6.67a12.9,12.9,0,0,1-.26,3.2c-.65,1.06-1.92,2.23-2.41,2.11-2.08-.53-1.91-7.88-1.91-7.88A20.3,20.3,0,0,1,83.24,157Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,124.07a15.11,15.11,0,0,0-12.36,6c-2.47,3.52-5.3,21.29-3.65,24.54S98,165.31,105.8,169c6.24,3,9.42,2.27,11.84,1.05,1.82-.92,1.78-3.93,1.94-6.15.43-5.74.89-16,4.46-19.18s7-4.08,8-1.47c0,0,1.13-3.77-6-7.9C114.35,128.5,105.18,124.43,99.43,124.07Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,124.07a15.11,15.11,0,0,0-12.36,6c-2.47,3.52-5.3,21.29-3.65,24.54S98,165.31,105.8,169c6.24,3,9.42,2.27,11.84,1.05,1.82-.92,1.78-3.93,1.94-6.15.43-5.74.89-16,4.46-19.18s7-4.08,8-1.47c0,0,1.13-3.77-6-7.9C114.35,128.5,105.18,124.43,99.43,124.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.43,131.26c-2.28,5.26-4.52,20.36-3,23.33C85.05,157.78,98,165.31,105.8,169c6.24,3,9.42,2.27,11.84,1.05,1.82-.92,1.78-3.93,1.94-6.15.32-4.21.66-10.87,2.22-15.37C114.33,144.9,94.51,135.23,86.43,131.26Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.64,155.84l4.12,1.84s-1.28,13.51-1.4,18.47c0,0-1,2.08-2,2.37s-2-2.17-2.19-4S106.08,160.11,106.64,155.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,156.81l4.2,1.73a.69.69,0,0,0,1-.59l.22-2a1.16,1.16,0,0,0-.67-1.12L107.05,153a.68.68,0,0,0-1,.58l-.22,2.12A1.15,1.15,0,0,0,106.49,156.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3,172.56a2.12,2.12,0,0,1,1.12,1.84.8.8,0,0,1-1.19.79,2.1,2.1,0,0,1-1.11-1.84C106.14,172.61,106.67,172.26,107.3,172.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.78,146.51l4,2.05S92.65,162,92.27,166.89c0,0-1.14,2-2.07,2.26s-1.93-2.26-2-4.07A184,184,0,0,1,89.78,146.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,147.48l4.11,1.94a.7.7,0,0,0,1-.54l.32-2a1.16,1.16,0,0,0-.61-1.15l-4.12-2a.68.68,0,0,0-1,.53L89,146.34A1.15,1.15,0,0,0,89.59,147.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,163.2a2.14,2.14,0,0,1,1,1.9.8.8,0,0,1-1.23.72,2.1,2.1,0,0,1-1-1.89C89.23,163.2,89.78,162.87,90.4,163.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,176.07c-.25-.15-3.92-3.14-4.35-3.38-.76-.43-12,6.45-13,7.66-.73.84.13,14.54.54,15.53.15.36,4.21,3,4.36,3.38.41,1,12.23-6,13-7.77S138.49,176.69,137.38,176.07Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,176.07c-.25-.15-3.92-3.14-4.35-3.38-.76-.43-12,6.45-13,7.66-.73.84.13,14.54.54,15.53.15.36,4.21,3,4.36,3.38.41,1,12.23-6,13-7.77S138.49,176.69,137.38,176.07Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.39,183.72c-.73.85.12,14.54.54,15.54s12.23-6,13-7.77.57-14.8-.54-15.42C136.63,175.64,125.43,182.51,124.39,183.72Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,172.69c.43.24,4.1,3.24,4.35,3.37-.75-.42-11.95,6.45-13,7.66L120,180.35C121.08,179.13,132.27,172.26,133,172.69Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.39,183.72c-.73.85.12,14.54.54,15.54s12.23-6,13-7.77.57-14.8-.54-15.42C136.63,175.64,125.43,182.51,124.39,183.72Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,180.35c.83-.49,3.27,1,4.32,1.91s2.12,5.31,4.85,6.13,6.67-2.6,7.52-4.88,1.91-7.1.61-8.91-3.6-2.87-5.56-1.93S120.31,178.23,120,180.35Z",
    style: {
      fill: "#438BAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,180.35c.83-.49,3.27,1,4.32,1.91s2.12,5.31,4.85,6.13,6.67-2.6,7.52-4.88,1.91-7.1.61-8.91-3.6-2.87-5.56-1.93S120.31,178.23,120,180.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.35,182.88a2,2,0,0,0-1,1.84.85.85,0,0,0,1.25.79,1.93,1.93,0,0,0,1-1.84C133.52,182.94,133,182.58,132.35,182.88Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.05,126.12c4.14-.07,5.69.94,8.77,1.55,4.19.82,20.19-2.4,20.19-2.4s6.48-.24,10.67,1.71c4.72,2.19,5.94,4.61,5.83,6.53-.14,2.69-2.09,4.19-7.08,6-3.93,1.39-23.07,6.63-30.1,7.51C134.06,148.28,129,131.59,136.05,126.12Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.79,125.88c5.43-.61,10.39-1,14.11,2.07-1.24-2.94-4.8-5-14.64-4Z",
    style: {
      fill: "#f0997a"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.451a3b95235e34600e6dd77863d988b0.svg";
export { ForwardRef as ReactComponent };